import React, { useState, useEffect } from "react";
import {
  Button,
  Divider,
  Layout,
  Tabs,
  Tooltip,
  Select,
  Badge,
  Avatar,
  Space,
} from "antd";
import Icon, { CloseOutlined } from "@ant-design/icons";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import SettingsLogo from "../../../../assets/Settings_Logo.svg";
import SettingLogoHover from "../../../../assets/setting_icon_blue.svg";
import { Content } from "antd/lib/layout/layout";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import {
  setPolificOrderByAttribute,
  setX_attribute,
  setY_attribute,
} from "../../../../redux/actions/WidgetMaker/GraphConfig";
import styled from "styled-components";
import EditFieldModal from "../../EditFieldModal/EditFieldModal";
import {
  deepCopy,
  getCustomizedDate,
  getWidgetMakerFlag,
  updateChartSettingsInGraphObjectBasedOnSelection,
} from "../../../../redux/constants";
import moment from "moment";
import {
  setWidgetMakerErrorCode,
  setWidgetMakerGraphData,
} from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import { setChartEditField } from "../../../../redux/actions/WidgetMaker/GraphConfig";
import informationButton from "../../../../assets/information-button.svg";
import { setOptionHighChart } from "../../../../redux/actions/HighChart";
import { setFilterActiveKey } from "../../../../redux/actions/Filter";
import { setWidgetMakerApiCallFlag } from "../../../../redux/actions/WidgetMaker/WidgetMaker";
import { supportedBenchmarkTraceChartTypes } from "../../../../redux/constants/enums";
import AttributeFieldConfig from "../AttributeFieldConfig/AttributeFieldConfig";
import uuid from "react-uuid";
const CloseIcon = (props) => <Icon component={CloseOutlined} {...props} />;
const { Option } = Select;

const EditAxisPanel = (props) => {
  const data_source = useSelector((state) => state.WidgetLibrary.data_source);
  const dispatch = useDispatch();
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const WM_attributes = useSelector((state) => state.WidgetMaker.WM_attributes);
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const wm_api_flag = useSelector((state) => state.WidgetMaker.wm_api_flag);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditionConfigurationData
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const graphConditionAggregation = useSelector(
    (state) => state?.apiCall?.graphConditions?.column_aggregations
  );
  const widgetMakerGraphData = useSelector(
    (state) => state?.WidgetAPI?.widget_maker_graph_data
  );
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);

  const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    padding: 0.8rem;
    margin-top: 1rem;
    height: auto;
    border: 0.1rem solid
      ${authParams?.theme_type === "1" ? "#d9e5ed" : "#c3cbd7"};
    background-color: ${authParams?.theme_type === "1" ? "" : "#ffffff"};
  `;
  const [widgetMakerClearFilter, setWidgetMakerClearFilter] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false); // New state for modal
  const [isFilterApplied, setisFilterApplied] = useState(false);
  const [filterSearch, setfilterSearch] = useState("");
  const [polificOptions, setPolificOptions] = useState("engagement");
  const [networkGraphOptions, setNetworkGraphOptions] = useState(null);
  const [pivotGroupBy, setPivotGroupBy] = useState();
  const [seriesBg, setSeriesBg] = useState();
  const [editName, setEditName] = useState();
  const [editAggregation, setAggregation] = useState("count");
  const [editPanelPosition, setEditPanelPosition] = useState(0);
  const [searchTerm, setSearchTerm] = useState(null);
  const [nssCase, setNssCase] = useState(false);

  const windowHeight = window?.innerHeight - editPanelPosition;
  useEffect(() => {
    handlePivotGroupBySuggetion(axisPanelAtt?.dragDataType?.attribute);
    if (widgetGraphConfig?.dragDataType?.int) {
      handleYseriesSuggetion();
    } else {
      setSeriesBg(false);
    }

    if (
      (widgetGraphConfig?.y_axis?.y_series_1?.attribute === "nss" ||
        widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs") &&
      widgetGraphConfig?.breakdown_by?.[0]?.attribute &&
      widgetGraphConfig?.x_axis?.attribute
    ) {
      setNssCase(true);
    }
  }, [axisPanelAtt]);

  let pivot_index = axisPanelAtt?.breakdown_by?.findIndex((d) => d.is_pivot);
  let chart_type = axisPanelAtt.chart_type;

  let y_series_array_drag = [];
  y_series_array_drag = Object.keys(axisPanelAtt?.y_axis)
    .map((key) => axisPanelAtt?.y_axis[key])
    .filter((d) => d?.attribute);

  let x = axisPanelAtt?.x_axis ? 1 : 0;
  let y = y_series_array_drag ? y_series_array_drag?.length : 0;
  let b = axisPanelAtt?.breakdown_by && axisPanelAtt?.breakdown_by?.length;
  let pivot = axisPanelAtt?.breakdown_by?.some((d) => d?.is_pivot);

  let combinedLength = x + y + b;
  let totalLength =
    chart_type === "network-graph" || chart_type === "network-graph-v2"
      ? combinedLength < 4
      : chart_type === "grid" ||
        chart_type === "rich-text" ||
        chart_type === "cluster-chart"
      ? combinedLength < 10
      : pivot
      ? combinedLength < 3
      : combinedLength < 2;

  const handleInput = () => {};

  const handleAddYSeries = (yAxis) => {
    dispatch(setWidgetMakerApiCallFlag(true)); //to not show error notification
    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        [yAxis]: {
          ...axisPanelAtt[yAxis],
          [`y_series_${Object.keys(axisPanelAtt.y_axis).length + 1}`]: {
            attribute: null,
            aggregation: "COUNT",
          },
        },
      })
    );
  };
  // Function to add multiple breakdown-by
  const handleAddBreakdownBy = (breakdown_by) => {
    let newBreakdownByObject = {
      attribute: null,
      date_part: null,
      sort_order: null,
      trace_name: null,
      y_limit: null,
    };
    dispatch(setWidgetMakerApiCallFlag(true)); //to not show error notification
    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        [breakdown_by]: [...axisPanelAtt[breakdown_by], newBreakdownByObject],
      })
    );
  };
  // Function to remove breakdown-by
  const removeBreakdownBy = (axispanelAtt, i) => {
    const updatedBreakdownBy = [...axisPanelAtt?.breakdown_by];
    updatedBreakdownBy?.splice(i, 1);
    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        breakdown_by: updatedBreakdownBy,
      })
    );
  };
  const onChange = (key) => {
    if (key === "filters") {
      setfilterSearch("");
      dispatch(setFilterActiveKey([]));
    }
  };

  const callChartAPI = (graphConfig, y_series) => {
    // let pivot_index =graphConfig?.breakdown_by?.findIndex((d) => d?.is_pivot);
    dispatch(setOptionHighChart({}));
    let y_series_array = [];
    y_series_array = Object.keys(graphConfig?.y_axis).map(
      (key) => graphConfig?.y_axis[key]
    );
    y_series_array = y_series_array?.filter((el) => el?.attribute);
    let y_series_flag = getWidgetMakerFlag(widgetGraphConfig, wm_api_flag);

    if (
      widgetGraphConfig?.chart_type === "bubble" ||
      widgetGraphConfig?.chart_type === "heatmap" ||
      widgetGraphConfig?.chart_type === "sunburst" ||
      widgetGraphConfig?.chart_type === "sankey" ||
      widgetGraphConfig?.chart_type === "wordcloud" ||
      widgetGraphConfig?.chart_type === "donut" ||
      widgetGraphConfig?.chart_type === "pie"
    ) {
      y_series_array =
        y_series_array?.length > 1 ? [y_series_array[0]] : y_series_array;
    }

    let twoMonthsDuration = getCustomizedDate(6, "Days");
    let defaultDuration = {
      from:
        moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.startTime,
      to:
        moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
        " " +
        twoMonthsDuration?.time?.endTime,
    };
    let card_settings_data = [];
    graphConfig?.card_settings?.map((d) => {
      if (
        (d?.x_axis?.attribute || (!d?.x_axis?.attribute && d?.y_series)) &&
        d?.y_series?.attribute
      ) {
        card_settings_data = [
          ...card_settings_data,
          {
            x_axis:
              d?.x_axis == null
                ? null
                : Object.keys(d?.x_axis).length == 0
                ? null
                : d?.x_axis,
            y_series: d?.y_series?.attribute ? d?.y_series : null,
          },
        ];
      }
    });

    if (!y_series_flag?.flag) {
      let card_settings_index =
        card_settings_data && card_settings_data?.length
          ? card_settings_data?.length - 1
          : 0;
      if (card_settings_data && card_settings_data?.length) {
        if (card_settings_data && Array.isArray(card_settings_data)) {
          for (let i = card_settings_data?.length - 1; i >= 0; i--) {
            let card = card_settings_data?.[i];
            if (card?.x_axis?.atrribute || card?.y_series) {
              card_settings_index = i;
              break;
            }
          }
        }
      }
      let graphObject = {
        data_source: data_source,
        brand_list: [
          {
            brand_id: 600,
          },
        ],
        start_date: widgetGraphConfig?.duration?.from
          ? widgetGraphConfig?.duration?.from
          : defaultDuration?.from,
        end_date: widgetGraphConfig?.duration?.to
          ? widgetGraphConfig?.duration?.to
          : defaultDuration?.to,
        brands: widgetGraphConfig?.brands
          ? widgetGraphConfig?.brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        isBrandModified: widgetGraphConfig?.brands ? true : false,
        edit: widgetGraphConfig?.edit,
        filters:
          widgetGraphConfig?.filters?.length > 0
            ? widgetGraphConfig?.filters
            : [],
        x_axis: graphConfig?.x_axis && graphConfig?.x_axis,
        // Break down data
        y_axes:
          graphConfig?.breakdown_by?.length > 0
            ? graphConfig?.breakdown_by
            : [],
        // y axis data
        y_series: y_series_array && y_series_array,
        // for filter dropdown in widget header
        filter_dropdown: graphConfig?.filter_dropdown || [],
        widget_name: "abc",
        chart: {
          chart_type:
            widgetGraphConfig?.chart_type === "donut"
              ? "pie"
              : widgetGraphConfig?.chart_type,
          rich_fields_content: widgetGraphConfig?.rich_fields_content,
          chart_settings: {
            ...graphConfig?.chart_settings,
            //duration_comparison: true,
            // duration_comparison: false, // This is used for only KPI
            // show_previous_duration_comparison: false, // This is used for charts
            // show_previous_duration_data: false, // This is used for charts
            // show_data_labels: true,
            // is_stacked: true,
            // show_count_cards: true,
            // card_percent: true,
            // chart_percent: false,
            // gradient_color: false,
            // split_cards: false,
            show_data_labels: graphConfig?.chart_settings?.global_data_label,
            show_details_on_card:
              graphConfig?.chart_settings?.show_details_on_card,
            show_as_median: graphConfig?.chart_settings?.show_as_median,
            show_3d: widgetGraphConfig?.chart_settings?.show_3d,
            settings_3d: widgetGraphConfig?.chart_settings?.settings_3d,
            show_horizontal_view:
              graphConfig?.chart_settings?.show_horizontal_view,
            show_label_names: graphConfig?.chart_settings?.show_label_names,
            show_count_cards: graphConfig?.chart_settings?.data_count_card,
            top_posts_in_cards: graphConfig?.chart_settings?.top_posts_in_cards,
            show_header:
              typeof graphConfig?.chart_settings?.show_header === "boolean"
                ? graphConfig?.chart_settings?.show_header
                : true,
            chart_property: {
              chart_name: "Line chart",
              legend_position: "top",
              y_axis_mode: graphConfig?.chart_property?.y_axis_mode,
              no_of_top_posts: graphConfig?.chart_property?.no_of_top_posts,
            },
            y_axes_settings: graphConfig?.y_axis_settings,
            cards_settings: card_settings_data ? card_settings_data : null,
            chart_styles: graphConfig?.chart_settings?.chart_styles || null,
            cluster_chart_type: graphConfig?.chart_settings?.cluster_chart_type,
            cluster_style: graphConfig?.chart_settings?.cluster_style,
          },
        },
        card_settings_index: card_settings_index,
        widgetGraphConfig: graphConfig,
        tags: widgetGraphConfig?.tags ? widgetGraphConfig?.tags : [],
        filter_by_dropdown: graphConfig?.filter_by_dropdown || [],
        filter_by_dropdown_data: graphConfig?.filter_by_dropdown_data || [],
        multilevel_breakdown: graphConfig?.multilevel_breakdown || null,
      };
      // Check and update chart settings based on benchmark line case
      let updatedGraphObject = updateChartSettingsInGraphObjectBasedOnSelection(
        {
          widgetGraphConfig: graphConfig,
          brandlogicalgroup: brandlogicalgroup,
          brands: brands,
          graphObject: graphObject,
        }
      );
      if (updatedGraphObject) {
        graphObject = updatedGraphObject;
      }
      if (widgetGraphConfig?.chart_type === "network-graph-v2") {
        graphObject.isNetworkChartV2 =
          graphObject?.chart?.chart_type === "network-graph-v2" ? true : false;
      }
      // let combination_chart_condition =
      //   graphConfig?.chart_type === "combination"
      //     ? graphConfig?.y_axis?.y_series_2?.attribute
      //       ? true
      //       : false
      //     : false;

      authParams &&
        graphConfig?.x_axis &&
        graphConfig?.y_axis?.y_series_1?.attribute &&
        !y_series &&
        dispatch(setWidgetMakerGraphData(authParams, graphObject));
    }
  };
  // Helper: get aggregation type
  const getAggregation = (attr) => {
    if (graphConditionAggregation?.avg?.includes(attr)) return "avg";
    if (graphConditionAggregation?.average_attribute?.includes(attr))
      return "avg";
    if (graphConditionAggregation?.count_distinct?.includes(attr))
      return "COUNT";
    if (graphConditionAggregation?.count?.includes(attr)) return "COUNT";
    if (graphConditionAggregation?.max?.includes(attr)) return "max";
    if (["nss", "srs"].includes(attr)) return "COUNT";
    return "SUM";
  };
  const deleteAxisAttribute = (axis, series, id) => {
    if (axis !== "fields") {
      dispatch({ type: "SET_WIDGET_MAKER_CHART", payload: null });
      dispatch(setWidgetMakerErrorCode(null));
    }

    if (axis === "x_axis") {
      if (
        axisPanelAtt?.chart_type !== "kpi" &&
        axisPanelAtt?.chart_type !== "rich-text"
      )
        dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
      if (
        axisPanelAtt?.chart_type === "grid" ||
        axisPanelAtt?.chart_type === "pivot-grid" ||
        axisPanelAtt?.chart_type === "rich-text" ||
        axisPanelAtt?.chart_type === "cluster-chart"
      ) {
        if (axisPanelAtt?.breakdown_by?.length === 0) {
          dispatch(
            setY_attribute({
              ...axisPanelAtt,
              [`x_axis`]: null,
              [`edit_fields`]: {
                ...axisPanelAtt.edit_fields,
                boolValue: false,
                trace_name: null,
              },
            })
          );
        } else if (axisPanelAtt?.breakdown_by?.length > 1) {
          let updatedBreakdownBy = deepCopy(axisPanelAtt?.breakdown_by)?.slice(
            1
          );
          let graphConfig = {
            ...axisPanelAtt,
            [`x_axis`]: {
              attribute: axisPanelAtt?.breakdown_by?.[0]?.attribute,
              data_source: axisPanelAtt?.breakdown_by?.[0]?.data_source,
              deep_dive_info: axisPanelAtt?.breakdown_by?.[0]?.deep_dive_info
                ? axisPanelAtt?.breakdown_by?.[0]?.deep_dive_info
                : null,
              trace_name:
                All_WM_attributes[axisPanelAtt?.breakdown_by?.[0]?.attribute],
              date_part: axisPanelAtt?.breakdown_by?.[0]?.date_part
                ? axisPanelAtt?.breakdown_by[0]?.date_part
                : null,
              sort_order: axisPanelAtt?.breakdown_by?.[0]?.sort_order
                ? axisPanelAtt?.breakdown_by[0]?.sort_order
                : "desc",
              span_on: axisPanelAtt?.breakdown_by?.[0]?.span_on
                ? axisPanelAtt?.breakdown_by[0]?.span_on
                : false,
              x_limit: axisPanelAtt?.chart_type === "rich-text" ? 1 : 50,
            },
            [`breakdown_by`]:
              updatedBreakdownBy?.length > 0
                ? updatedBreakdownBy
                : [
                    {
                      attribute: axisPanelAtt?.breakdown_by?.[1]?.attribute,
                      data_source: axisPanelAtt?.breakdown_by?.[1]?.data_source,
                      deep_dive_info: axisPanelAtt?.breakdown_by?.[1]
                        ?.deep_dive_info
                        ? axisPanelAtt?.breakdown_by?.[1]?.deep_dive_info
                        : null,
                      trace_name:
                        All_WM_attributes[
                          axisPanelAtt?.breakdown_by?.[1]?.attribute
                        ],
                      date_part: axisPanelAtt?.breakdown_by?.[1]?.date_part
                        ? axisPanelAtt?.breakdown_by[1]?.date_part
                        : null,
                      sort_order: axisPanelAtt?.breakdown_by?.[1]?.sort_order
                        ? axisPanelAtt?.breakdown_by[1]?.sort_order
                        : "desc",
                      span_on: axisPanelAtt?.breakdown_by?.[1]?.span_on
                        ? axisPanelAtt?.breakdown_by[1]?.span_on
                        : false,
                      y_limit: axisPanelAtt?.chart_type === "rich-text" ? 1 : 5,
                    },
                  ],
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
              trace_name: null,
            },
          };
          dispatch(setY_attribute(graphConfig));
          if (axisPanelAtt?.chart_type !== "rich-text") {
            dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
            callChartAPI(graphConfig);
          }
        } else {
          let graphConfig = {
            ...axisPanelAtt,
            [`x_axis`]: {
              attribute: axisPanelAtt?.breakdown_by?.[0]?.attribute,
              data_source: axisPanelAtt?.breakdown_by?.[0]?.data_source,
              deep_dive_info: axisPanelAtt?.breakdown_by?.[0]?.deep_dive_info
                ? axisPanelAtt?.breakdown_by?.[0]?.deep_dive_info
                : null,
              trace_name:
                All_WM_attributes[axisPanelAtt?.breakdown_by?.[0]?.attribute],
              date_part: axisPanelAtt?.breakdown_by?.[0]?.date_part
                ? axisPanelAtt?.breakdown_by[0]?.date_part
                : null,
              sort_order: axisPanelAtt?.breakdown_by?.[0]?.sort_order
                ? axisPanelAtt?.breakdown_by[0]?.sort_order
                : "desc",
              span_on: axisPanelAtt?.breakdown_by?.[0]?.span_on
                ? axisPanelAtt?.breakdown_by[0]?.span_on
                : false,
              x_limit: axisPanelAtt?.chart_type === "rich-text" ? 1 : 50,
            },
            [`breakdown_by`]: [],
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
              trace_name: null,
            },
          };
          dispatch(setY_attribute(graphConfig));
          if (axisPanelAtt?.chart_type !== "rich-text") {
            dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
            callChartAPI(graphConfig);
          }
        }
      } else {
        dispatch(
          setX_attribute({
            ...axisPanelAtt,
            [axis]: null,
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
              trace_name: null,
            },
          })
        );
      }
    } else if (axis === "order_by") {
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [axis]: null,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
            trace_name: null,
          },
        })
      );
    } else if (axis === "review-card") {
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [`order_by`]: null,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
            trace_name: null,
          },
        })
      );
    } else if (axis === "survey-card") {
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [`order_by`]: null,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
            trace_name: null,
          },
        })
      );
    } else if (axis === "author-card") {
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [`order_by`]: null,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
            trace_name: null,
          },
        })
      );
    } else if (axis === "filter_by") {
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          [axis]: null,
          [`postcard_pills_filter`]: null,
          [`breakdown_by`]: [],
          [`filter_by_data`]: null,
          [`order_by`]: axisPanelAtt?.order_by
            ? { ...axisPanelAtt?.order_by, offset: 0 }
            : null,
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
            trace_name: null,
          },
        })
      );
    } else if (axis === "y_axis") {
      if (
        series === "y_series_1" &&
        (widgetGraphConfig?.y_axis?.y_series_1?.attribute === "nss" ||
          widgetGraphConfig?.y_axis?.y_series_1?.attribute === "srs")
      ) {
        let graphConfig = {
          ...axisPanelAtt,
          [axis]: {
            ...axisPanelAtt[axis],
            [series]: {
              ...axisPanelAtt[axis][series],
              [`attribute`]: null,
              trace_name: null,
              filters: [],
            },
          },
          [`x_axis`]: null,
          [`breakdown_by`]: [],
          [`dragDataType`]: {
            varchar: false,
            int: false,
            datetime: false,
            json: false,
          },
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        };
        dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
        dispatch(setY_attribute(graphConfig));
        callChartAPI(graphConfig, true);
        setNssCase(false);
      } else {
        let filteredAxis;
        if (series === "y_series_1") {
          filteredAxis = axisPanelAtt?.y_axis_settings;
        } else {
          filteredAxis =
            axisPanelAtt?.y_axis_settings?.length > 0
              ? axisPanelAtt?.y_axis_settings?.filter((d) => d.key !== id)
              : [];
        }

        let graphConfig = {
          ...axisPanelAtt,
          [axis]: {
            ...axisPanelAtt[axis],
            [series]: {
              ...axisPanelAtt[axis][series],
              [`attribute`]: null,
              trace_name: null,
              data_source: null,
              filters: [],
            },
          },
          [`y_axis_settings`]: [...filteredAxis],
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        };
        dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
        dispatch(setY_attribute(graphConfig));
        callChartAPI(graphConfig, true);
      }
    } else if (axis === "breakdown_by") {
      let graphConfig = {};
      if (id >= 0) {
        if (series === "sankey" && id) {
          let sankeyBreakdownBy = deepCopy(axisPanelAtt?.breakdown_by);
          sankeyBreakdownBy[id].attribute = null;
          sankeyBreakdownBy[id].config_filters = null;
          sankeyBreakdownBy[id].trace_name = null;
          graphConfig = {
            ...axisPanelAtt,
            [`breakdown_by`]: [...sankeyBreakdownBy],
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          };
        } else {
          let filtered = axisPanelAtt?.breakdown_by?.filter((d, i) => i !== id);

          graphConfig = {
            ...axisPanelAtt,
            [`breakdown_by`]: [...filtered],
            [`edit_fields`]: {
              ...axisPanelAtt.edit_fields,
              boolValue: false,
            },
          };

          if (axisPanelAtt?.chart_type === "combination") {
            graphConfig.chart_settings.is_stacked = false;
            graphConfig.chart_settings.gradient_color = true;
          }
        }
        dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
        dispatch(setX_attribute(graphConfig));
        if (
          axisPanelAtt?.chart_type !== "pivot-grid" &&
          axisPanelAtt?.chart_type !== "bubble" &&
          axisPanelAtt?.chart_type !== "heatmap" &&
          axisPanelAtt?.chart_type !== "sunburst" &&
          axisPanelAtt?.chart_type !== "network-graph" &&
          axisPanelAtt?.chart_type !== "network-graph-v2"
        ) {
          callChartAPI(graphConfig);
        }
      } else {
        let graphConfig = {
          ...axisPanelAtt,
          [`breakdown_by`]: [],
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        };
        if (axisPanelAtt?.chart_type === "combination") {
          graphConfig.chart_settings.is_stacked = false;
          graphConfig.chart_settings.gradient_color = true;
        }
        dispatch(setWidgetMakerApiCallFlag(true)); //to stop api call from useeffect
        dispatch(setX_attribute(graphConfig));
        if (
          axisPanelAtt?.chart_type !== "pivot-grid" &&
          axisPanelAtt?.chart_type !== "bubble" &&
          axisPanelAtt?.chart_type !== "heatmap" &&
          axisPanelAtt?.chart_type !== "sankey" &&
          axisPanelAtt?.chart_type !== "sunburst" &&
          axisPanelAtt?.chart_type !== "network-graph" &&
          axisPanelAtt?.chart_type !== "network-graph-v2"
        ) {
          callChartAPI(graphConfig);
        }
      }
    } else if (axis === "filter_dropdown") {
      let graphConfig = {};
      if (id >= 0) {
        let filtered = axisPanelAtt?.filter_dropdown?.filter(
          (d, i) => i !== id
        );

        graphConfig = {
          ...axisPanelAtt,
          [`filter_dropdown`]: [...filtered],
          [`filter_by_dropdown`]: [],
          [`filter_by_dropdown_data`]: [],
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        };
        dispatch(setX_attribute(graphConfig));
      } else {
        let graphConfig = {
          ...axisPanelAtt,
          [`filter_dropdown`]: [],
          [`filter_by_dropdown`]: [],
          ["filter_by_dropdown_data"]: [],
          [`edit_fields`]: {
            ...axisPanelAtt.edit_fields,
            boolValue: false,
          },
        };
        dispatch(setX_attribute(graphConfig));
      }
    } else if (axis === "fields") {
      let updatedFieldsArr = axisPanelAtt?.fields?.filter((e) => e !== series);

      dispatch(
        setX_attribute({
          ...axisPanelAtt,
          [axis]: updatedFieldsArr,
        })
      );
    }
  };

  const removeYSeries = (yAxis, series) => {
    // To clear the widget chart data for Grid and Pivot chart
    if (series === "y_series_1" && axisPanelAtt?.chart_type !== "rich-text") {
      dispatch({ type: "SET_WIDGET_MAKER_CHART", payload: null });
      dispatch(setWidgetMakerErrorCode(null));
    }

    let updateYseries = axisPanelAtt;
    if (!updateYseries[yAxis][series]?.attribute && widgetMakerGraphData) {
      dispatch(setWidgetMakerApiCallFlag(true));
    }
    delete updateYseries[yAxis][series];

    let finalUpdateYseries = {};
    Object.entries(updateYseries[yAxis]).forEach((e, i) => {
      finalUpdateYseries = {
        ...finalUpdateYseries,
        [`y_series_${i + 1}`]: { ...e[1] },
      };
    });
    let fallbackYSeriesAddedForRichText = false;
    let fallbackYSeries = null;
    if (
      axisPanelAtt?.chart_type === "rich-text" &&
      axisPanelAtt?.x_axis?.attribute &&
      Object.keys(finalUpdateYseries)?.length === 0
    ) {
      let fallbackYAttr = null;
      let newDataSource =
        axisPanelAtt?.x_axis?.data_source ||
        axisPanelAtt?.data_source ||
        "mentions";
      fallbackYAttr =
        newDataSource === "tickets"
          ? "caseid"
          : newDataSource === "page"
          ? "page_followers_count"
          : "tagid";
      fallbackYSeries = {
        attribute: fallbackYAttr,
        aggregation: getAggregation(fallbackYAttr),
        trace_name: All_WM_attributes[fallbackYAttr],
        data_source: newDataSource,
        hide_on_ui: true,
      };
      fallbackYSeriesAddedForRichText = true;
    }

    Object.keys(finalUpdateYseries)?.length !== 0
      ? dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [yAxis]: finalUpdateYseries,
          })
        )
      : dispatch(
          setY_attribute({
            ...axisPanelAtt,
            [yAxis]: {
              [`y_series_1`]:
                fallbackYSeriesAddedForRichText && fallbackYSeries
                  ? { ...fallbackYSeries }
                  : { attribute: null },
            },
          })
        );
  };
  const removeNode = (nodeIndex, nodeAttribute) => {
    let updateAxisPanelAtt = { ...axisPanelAtt };
    delete updateAxisPanelAtt["y_axis"][`y_series_${nodeIndex + 2}`];
    let finalUpdateYseries = {};
    Object.entries(updateAxisPanelAtt["y_axis"])?.forEach((e, i) => {
      finalUpdateYseries = {
        ...finalUpdateYseries,
        [`y_series_${i + 1}`]: { ...e[1] },
      };
    });
    let updatedBreakdownBy = [];
    if (nodeIndex >= 0) {
      updatedBreakdownBy = axisPanelAtt?.breakdown_by?.filter(
        (d, i) => i !== nodeIndex
      );
    } else {
      updatedBreakdownBy = [];
    }
    dispatch(
      setY_attribute({
        ...axisPanelAtt,
        ["y_axis"]:
          Object.keys(finalUpdateYseries)?.length !== 0
            ? finalUpdateYseries
            : { [`y_series_1`]: { attribute: null } },
        [`data_source`]: null,
        [`breakdown_by`]: updatedBreakdownBy,
        [`edit_fields`]: {
          ...axisPanelAtt.edit_fields,
          boolValue: false,
        },
      })
    );
  };
  const openEditFields = (openFieldsValues) => {
    const {
      series,
      attName,
      agg,
      sort_order,
      x_limit,
      date_part,
      y_limit,
      chart_type,
      percent,
      breakdown_index,
      is_pivot,
      event,
      span_on,
      info_text = "",
      variable_size = false,
      radius_attribute = null,
      seriesColor = null,
    } = openFieldsValues || {};

    setIsModalVisible(true);
    if (event?.clientY) {
      // setEditPanelPosition(event.clientY);
    }

    let isSpanDisabled = false;
    let spanDisabledMsg = "";
    let isVariableSizeDisabled = false;
    let variableSizeMsg = "";

    let data_source = axisPanelAtt?.data_source;
    let deep_dive_info = null;
    // for setting data source for breakdown by, x_axis and y_axis
    if (series == "x_axis") {
      data_source = axisPanelAtt?.x_axis?.data_source;
      deep_dive_info = axisPanelAtt?.x_axis?.deep_dive_info || null;
    } else if (series === "breakdown") {
      if (
        Array.isArray(axisPanelAtt?.breakdown_by) &&
        axisPanelAtt?.breakdown_by?.length > 1
      ) {
        axisPanelAtt?.breakdown_by?.forEach((b, i) => {
          if (i === breakdown_index) {
            data_source = b?.data_source;
            deep_dive_info = b?.deep_dive_info || null;
          }
        });
      }
    } else {
      data_source = axisPanelAtt?.y_axis?.[series]?.data_source;
      deep_dive_info = axisPanelAtt?.y_axis?.[series]?.deep_dive_info || null;
    }

    if (series === "breakdown") {
      if (axisPanelAtt?.x_axis?.span_on) {
        isSpanDisabled = true;
      } else if (
        Array.isArray(axisPanelAtt?.breakdown_by) &&
        axisPanelAtt?.breakdown_by?.length > 1
      ) {
        axisPanelAtt?.breakdown_by?.forEach((b, i) => {
          if (b?.span_on && i !== breakdown_index) {
            isSpanDisabled = true;
          }
        });
      }
    } else if (
      series === "x_axis" &&
      Array.isArray(axisPanelAtt?.breakdown_by) &&
      axisPanelAtt?.breakdown_by?.length
    ) {
      axisPanelAtt?.breakdown_by?.forEach((b) => {
        if (b?.span_on) {
          isSpanDisabled = true;
        }
      });
    }
    if (
      axisPanelAtt?.chart_settings?.show_previous_duration_comparison ||
      axisPanelAtt?.chart_settings?.show_previous_duration_data
    ) {
      isSpanDisabled = true;
      spanDisabledMsg = "Disable data comparison to enable spanning.";
    }

    // For variable size
    if (series?.includes("y_series")) {
      const seriesIndex = series?.split("_")[2];
      let ySeriesFromConfig = Object?.entries(axisPanelAtt?.y_axis);
      ySeriesFromConfig?.forEach((yseries, index) => {
        if (yseries && Array.isArray(yseries) && yseries?.[1]?.attribute) {
          if (
            yseries?.[1]?.variable_size &&
            index !== parseInt(seriesIndex - 1)
          ) {
            isVariableSizeDisabled = true;
            variableSizeMsg = "";
          }
        }
      });
    }

    let data = {
      boolValue: true,
      series: series ? series : null,
      attName: attName ? attName : null,
      aggregation: agg ? agg : null,
      x_axis_sort_order: sort_order ? sort_order : null,
      x_axis_x_limit: x_limit >= 0 ? x_limit : null,
      x_axis_date_part: date_part ? date_part : null,
      y_axis_y_limit: y_limit >= 0 ? y_limit : null,
      chart_type: chart_type ? chart_type : null,
      percent: percent,
      breakdown_index: breakdown_index >= 0 ? breakdown_index : null,
      is_pivot: is_pivot,
      span_on: span_on,
      span_disabled: isSpanDisabled,
      span_disabled_msg: spanDisabledMsg,
      variable_size: variable_size,
      variable_size_disabled: isVariableSizeDisabled,
      variable_size_msg: variableSizeMsg,
      info_text: info_text,
      data_source: data_source,
      deep_dive_info: deep_dive_info,
      radius_attribute:
        radius_attribute && radius_attribute?.trim()?.length > 0
          ? radius_attribute
          : null,
      seriesColor:
        seriesColor && seriesColor?.trim()?.length > 0 ? seriesColor : null,
    };
    dispatch(setChartEditField(data, axisPanelAtt));
  };

  const handlePivotGroupBySuggetion = (name) => {
    let check;
    graphConditionConfig?.forEach((d) => {
      if (d === name) {
        check = true;
      }
    });
    setPivotGroupBy(check);
  };

  const handleprolificChange = (value) => {
    setPolificOptions(value);
    let obj = {};
    if (value === "firstPost") {
      obj = {
        attribute: value,
        offset: 0,
        sort_order: "asc",
      };
    } else {
      obj = {
        attribute: value,
        offset: 0,
        sort_order: "desc",
      };
    }
    dispatch(setPolificOrderByAttribute(obj, widgetGraphConfig));
  };

  const handleYseriesSuggetion = (name) => {
    let check;
    if (
      axisPanelAtt.dragDataType.int &&
      axisPanelAtt.dragDataType.attribute !== "nss" &&
      axisPanelAtt.dragDataType.attribute !== "srs" &&
      (!graphConditions?.["time-label-attrs"]?.includes(
        widgetGraphConfig?.y_axis?.y_series_1?.attribute
      ) ||
        !graphConditions?.["ticket-time-label-attrs"]?.includes(
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ))
    ) {
      check = true;
    } else if (
      axisPanelAtt.dragDataType.int &&
      (axisPanelAtt.dragDataType.attribute === "nss" ||
        axisPanelAtt.dragDataType.attribute === "srs") &&
      (axisPanelAtt.chart_type === "bar" ||
        axisPanelAtt.chart_type === "horizontal-bar" ||
        axisPanelAtt.chart_type === "lollipop" ||
        axisPanelAtt.chart_type === "area" ||
        axisPanelAtt.chart_type === "line" ||
        axisPanelAtt.chart_type === "scatter" ||
        axisPanelAtt.chart_type === "quadrant" ||
        axisPanelAtt.chart_type === "multilayer-map" ||
        axisPanelAtt.chart_type === "treemap")
    ) {
      check = true;
    } else if (
      graphConditions?.["time-label-attrs"]?.includes(
        widgetGraphConfig?.y_axis?.y_series_1?.attribute
      ) ||
      graphConditions?.["ticket-time-label-attrs"]?.includes(
        widgetGraphConfig?.y_axis?.y_series_1?.attribute
      )
    ) {
      if (
        (widgetGraphConfig?.chart_type === "combination" &&
          (graphConditions?.["time-label-attrs"]?.includes(
            widgetGraphConfig?.y_axis?.y_series_1?.attribute
          ) ||
            graphConditions?.["ticket-time-label-attrs"]?.includes(
              widgetGraphConfig?.y_axis?.y_series_1?.attribute
            )) &&
          !graphConditions?.["time-label-attrs"]?.includes(
            axisPanelAtt.dragDataType.attribute
          )) ||
        !graphConditions?.["ticket-time-label-attrs"]?.includes(
          axisPanelAtt.dragDataType.attribute
        )
      ) {
        check = true;
      } else if (
        ((widgetGraphConfig?.chart_type === "bar" ||
          widgetGraphConfig?.chart_type === "horizontal-bar" ||
          widgetGraphConfig?.chart_type === "lollipop" ||
          widgetGraphConfig?.chart_type === "area" ||
          widgetGraphConfig?.chart_type === "line" ||
          widgetGraphConfig?.chart_type === "treemap" ||
          widgetGraphConfig?.chart_type === "scatter" ||
          widgetGraphConfig?.chart_type === "quadrant") &&
          graphConditions?.["time-label-attrs"]?.includes(
            widgetGraphConfig?.y_axis?.y_series_1?.attribute
          )) ||
        (graphConditions?.["ticket-time-label-attrs"]?.includes(
          widgetGraphConfig?.y_axis?.y_series_1?.attribute
        ) &&
          graphConditions?.["time-label-attrs"]?.includes(
            axisPanelAtt.dragDataType.attribute
          )) ||
        graphConditions?.["ticket-time-label-attrs"]?.includes(
          axisPanelAtt.dragDataType.attribute
        )
      ) {
        check = true;
      }
    } else {
      check = false;
    }
    setSeriesBg(check);
  };

  let enableBreakdownBy =
    axisPanelAtt?.y_axis?.y_series_1?.attribute &&
    graphConditions?.common
      ?.map((d) => d?.attribute)
      ?.includes(axisPanelAtt?.y_axis?.y_series_1?.attribute)
      ? false
      : true;
  const getDataSourceOfThisAttribute = (attributeName) => {
    let datasource;
    let attributes = { ...WM_attributes };

    // Handle both old and new attribute structures
    if (attributes && typeof attributes === "object") {
      // First, try the old nested structure
      Object.entries(attributes)?.forEach((data_source) => {
        if (data_source?.[1] && typeof data_source[1] === "object") {
          Object.entries(data_source?.[1])?.forEach((el) => {
            if (el[1] && Array.isArray(el[1])) {
              el[1]?.forEach((g) => {
                if (
                  Array.isArray(g) &&
                  g[0]?.toLowerCase() === attributeName?.toLowerCase()
                ) {
                  datasource = graphConditions?.grp_src_map?.[data_source?.[0]];
                }
              });
            }
          });
        }
      });

      // If not found in old structure, try new direct data source structure
      if (!datasource) {
        ["common", "author", "mentions", "page", "tickets"].forEach(
          (dataSourceKey) => {
            const dataSourceValue = attributes[dataSourceKey];
            if (dataSourceValue && typeof dataSourceValue === "object") {
              Object.entries(dataSourceValue).forEach((categoryEntry) => {
                if (categoryEntry[1] && typeof categoryEntry[1] === "object") {
                  Object.entries(categoryEntry[1]).forEach((attrEntry) => {
                    if (
                      attrEntry[0]?.toLowerCase() ===
                      attributeName?.toLowerCase()
                    ) {
                      // Map the data source key to the appropriate source using grp_src_map
                      datasource =
                        graphConditions?.grp_src_map?.[dataSourceKey] ||
                        dataSourceKey;
                    }
                  });
                }
              });
            }
          }
        );
      }

      // If still not found, check All_WM_attributes as fallback
      if (!datasource && All_WM_attributes) {
        const foundInAllAttributes =
          All_WM_attributes[attributeName?.toLowerCase()];
        if (foundInAllAttributes) {
          // Default to 'mentions' if found in All_WM_attributes but no specific source determined
          datasource = "mentions";
        }
      }
    }

    return datasource;
  };
  const handleYSeriesAttributeChange = (value, index) => {
    let filterVal = {};
    Object.entries(axisPanelAtt?.y_axis).forEach((e) => {
      if (e[1]?.attribute !== null) {
        filterVal = { ...filterVal, [e[0]]: e[1] };
      }
    });
    if (
      !Object?.keys(filterVal)?.length ||
      value?.toLowerCase() !==
        axisPanelAtt?.y_axis?.[
          `y_series_${index + 1}`
        ]?.attribute?.toLowerCase()
    ) {
      let attributeDetails =
        Array.isArray(networkGraphOptions) &&
        networkGraphOptions?.find((a) => {
          return a?.attribute?.toLowerCase() === value?.toLowerCase();
        });
      dispatch(
        setY_attribute({
          ...axisPanelAtt,
          y_axis: {
            ...filterVal,
            [`y_series_${index + 1}`]: attributeDetails,
          },
          [`dragDataType`]: {
            ...axisPanelAtt[`dragDataType`],
            varchar: false,
            int: false,
            datetime: false,
          },
          [`y_axis_settings`]: axisPanelAtt.y_axis[`y_series_${index + 1}`]
            ?.attribute
            ? [...axisPanelAtt[`y_axis_settings`]]
            : `y_series_${index + 1}` === "y_series_1" &&
              axisPanelAtt?.y_axis_settings?.length > 0
            ? [...axisPanelAtt[`y_axis_settings`]]
            : [
                ...axisPanelAtt[`y_axis_settings`],
                {
                  show_as:
                    axisPanelAtt?.y_axis_settings?.length === 0
                      ? "bar"
                      : "line",
                  y_axis_map_at:
                    axisPanelAtt?.y_axis_settings?.length === 0 ? 0 : 1,
                  show_markers: true,
                  show_data_label: true,
                  y_axis_scale: "linear",
                  color_pattern_code: 1,
                  key: uuid(),
                },
              ],
        })
      );
    }
  };
  useEffect(() => {
    if (
      Array.isArray(graphConditions?.["network-graph"]?.int?.include) &&
      graphConditions?.["network-graph"]?.int?.include?.length > 0
    ) {
      let options = graphConditions?.["network-graph"]?.int?.include
        ?.map((attributeName) => {
          if (attributeName && attributeName?.length > 0) {
            let attr = {
              attribute: attributeName,
              data_source: getDataSourceOfThisAttribute(attributeName),
              aggregation: graphConditionAggregation?.count_distinct?.includes(
                attributeName
              )
                ? "COUNT"
                : graphConditionAggregation?.count?.includes(attributeName)
                ? "COUNT"
                : graphConditionAggregation?.max?.includes(attributeName)
                ? "max"
                : graphConditions?.[`latest-agg-columns`]?.includes(
                    attributeName
                  )
                ? "latest"
                : attributeName === "nss"
                ? "COUNT"
                : attributeName === "srs"
                ? "COUNT"
                : "SUM",
              trace_name: All_WM_attributes[attributeName],
            };
            return attr;
          } else {
            return null;
          }
        })
        ?.filter((e) => e);
      setNetworkGraphOptions(options?.length > 0 ? options : []);
    }
  }, [graphConditions?.["network-graph"]?.int?.include]);
  return (
    <>
      <AttributeFieldConfig />

      <div style={{ display: "none" }}>
        {!(
          chart_type === "map" ||
          chart_type === "grid" ||
          chart_type === "post-card" ||
          chart_type === "survey-card" ||
          chart_type === "pivot-grid" ||
          chart_type === "prolific-user" ||
          chart_type === "review-card" ||
          chart_type === "author-card" ||
          chart_type === "news-card" ||
          chart_type === "rich-text" ||
          chart_type === "network-graph" ||
          chart_type === "network-graph-v2"
        ) && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600">
                {chart_type === "pie" ||
                chart_type === "donut" ||
                chart_type === "wordcloud" ||
                chart_type === "kpi" ||
                chart_type === "progress-kpi"
                  ? "Breakdown By"
                  : ["scatter", "multilayer-map"]?.includes(chart_type)
                  ? "Varchar"
                  : "X-axis"}{" "}
                {chart_type !== "kpi" && chart_type !== "progress-kpi" && (
                  <span className="error">*</span>
                )}
              </div>

              <Droppable droppableId="x_axis">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        !axisPanelAtt?.x_axis?.attribute ? "dashed" : "solid"
                      } ${
                        (chart_type === "kpi" ||
                          chart_type === "progress-kpi") &&
                        (axisPanelAtt?.dragDataType?.attribute === "Keyword" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "TagCloud" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "Hashtags" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "CreatedDate")
                          ? "#9CB4FF"
                          : (chart_type === "wordcloud" ||
                              chart_type === "bubble" ||
                              chart_type === "heatmap" ||
                              chart_type === "sankey" ||
                              chart_type === "sunburst") &&
                            axisPanelAtt?.dragDataType?.attribute === "Rating"
                          ? "#9CB4FF"
                          : (!nssCase &&
                              axisPanelAtt?.dragDataType?.varchar &&
                              axisPanelAtt?.breakdown_by?.[0]?.attribute !==
                                axisPanelAtt?.dragDataType?.attribute) ||
                            (axisPanelAtt?.dragDataType?.datetime &&
                              [
                                "combination",
                                "bar",
                                "horizontal-bar",
                                "lollipop",
                                "area",
                                "line",
                                "pie",
                                "donut",
                                "scatter",
                                "quadrant",
                              ]?.includes(chart_type))
                          ? "#DDDDDD"
                          : !axisPanelAtt?.x_axis?.attribute
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        (chart_type === "kpi" ||
                          chart_type === "progress-kpi") &&
                        (axisPanelAtt?.dragDataType?.attribute === "Keyword" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "TagCloud" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "Hashtags" ||
                          axisPanelAtt?.dragDataType?.attribute ===
                            "CreatedDate")
                          ? null
                          : (chart_type === "wordcloud" ||
                              chart_type === "bubble" ||
                              chart_type === "heatmap" ||
                              chart_type === "sankey" ||
                              chart_type === "sunburst") &&
                            axisPanelAtt?.dragDataType?.attribute === "Rating"
                          ? null
                          : !nssCase &&
                            ((axisPanelAtt?.dragDataType?.varchar &&
                              axisPanelAtt?.breakdown_by?.[0]?.attribute !==
                                axisPanelAtt?.dragDataType?.attribute) ||
                              (axisPanelAtt?.dragDataType?.datetime &&
                                [
                                  "combination",
                                  "bar",
                                  "horizontal-bar",
                                  "lollipop",
                                  "area",
                                  "line",
                                  "pie",
                                  "donut",
                                  "scatter",
                                  "quadrant",
                                ]?.includes(chart_type))) &&
                            `0 0.2rem 0.5rem ${
                              authParams?.theme_type === "1"
                                ? "#fff"
                                : "rgb(103 139 255 / 50%)"
                            } `,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : !axisPanelAtt?.x_axis?.attribute
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {!axisPanelAtt?.x_axis?.attribute ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="cursor-pointer p-2 d-flex align-items-center justify-content-between"
                        onClick={(e) =>
                          openEditFields({
                            series: "x_axis",
                            attName: axisPanelAtt?.x_axis.attribute,
                            agg: axisPanelAtt?.x_axis.aggregation,
                            sort_order: axisPanelAtt?.x_axis?.sort_order,
                            x_limit: axisPanelAtt?.x_axis?.x_limit,
                            date_part: axisPanelAtt?.x_axis?.date_part,
                            seriesColor: axisPanelAtt?.x_axis?.color,
                            chart_type: chart_type,
                            event: e,
                          })
                        }
                        style={{ width: "90%" }}
                      >
                        <span className="text-ellipsis">
                          <Tooltip
                            title={
                              All_WM_attributes[axisPanelAtt?.x_axis.attribute]
                            }
                          >
                            {All_WM_attributes[axisPanelAtt?.x_axis.attribute]
                              ?.length > 17
                              ? All_WM_attributes[
                                  axisPanelAtt?.x_axis.attribute
                                ]?.substr(0, 17) + " ..."
                              : All_WM_attributes[
                                  axisPanelAtt?.x_axis.attribute
                                ]}
                          </Tooltip>
                        </span>
                        <Tooltip title={"Attribute Configuration"}>
                          {" "}
                          <img
                            src={
                              authParams?.theme_type === "1"
                                ? SettingsLogo
                                : SettingLogoHover
                            }
                            alt="arrow"
                            className="accordionArrow ml-15"
                            style={{
                              transform: `rotate("180deg")`,
                            }}
                          />
                        </Tooltip>
                      </span>
                    )}
                    {widgetGraphConfig?.y_axis?.y_series_1?.attribute !==
                      "nss" &&
                      widgetGraphConfig?.y_axis?.y_series_1?.attribute !==
                        "srs_temp" &&
                      axisPanelAtt?.x_axis?.attribute && (
                        <CloseIcon
                          className="mr-2"
                          onClick={() => deleteAxisAttribute("x_axis")}
                        />
                      )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
          </Layout>
        )}
        {chart_type === "prolific-user" && (
          <Select
            defaultValue={polificOptions}
            className="w-100"
            onChange={handleprolificChange}
            dropdownClassName={
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }
          >
            <Option value="engagement">Most Engaged Post</Option>
            <Option value="mostPost">Most Recent post</Option>
            <Option value="firstPost">First Post</Option>
          </Select>
        )}
        {[
          "combination",
          "line",
          "horizontal-bar",
          "lollipop",
          "bar",
          "area",
          "scatter",
          "quadrant",
          "multilayer-map",
        ]?.includes(chart_type)
          ? Object.entries(axisPanelAtt?.y_axis).map((el, i) => {
              let splitHeading = el[0].split("_");
              let finalHeading = ["scatter", "multilayer-map"]?.includes(
                chart_type
              )
                ? `Series ${splitHeading[2]}`
                : `${splitHeading[0].toUpperCase()}-${splitHeading[1]} ${
                    splitHeading[2]
                  }`;
              return (
                <Layout className="mt-3 bg-white " index={i}>
                  <Content>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="text_regular font-weight600">
                        {finalHeading}{" "}
                        {(i === 0 ||
                          !el?.attribute ||
                          (["combination", "scatter"]?.includes(chart_type) &&
                            i <= 1)) && <span className="error">*</span>}
                      </div>
                      {i > 0 && (
                        <span
                          onClick={() => removeYSeries("y_axis", el[0])}
                          style={{
                            color:
                              authParams?.theme_type === "1"
                                ? "#678BFF"
                                : "#185EDF",
                            cursor: "pointer",
                          }}
                        >
                          {["combination", "scatter"]?.includes(chart_type) &&
                          i === 1 ? (
                            ""
                          ) : (
                            <>Remove {finalHeading}</>
                          )}
                        </span>
                      )}
                    </div>
                    <Droppable droppableId={`y_axis#${el[0]}#attribute`}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center flex-wrap"
                          style={{
                            border: `0.1rem ${
                              !el[1].attribute ? "dashed" : "solid"
                            } ${
                              axisPanelAtt?.dragDataType.int
                                ? "#DDDDDD"
                                : !el[1].attribute
                                ? "#9CB4FF"
                                : "#d9e5ed"
                            }`,
                            boxShadow:
                              (axisPanelAtt.chart_type === "combination" &&
                                (graphConditions?.[
                                  "time-label-attrs"
                                ]?.includes(
                                  widgetGraphConfig?.dragDataType?.attribute
                                ) ||
                                  graphConditions?.[
                                    "ticket-time-label-attrs"
                                  ]?.includes(
                                    widgetGraphConfig?.dragDataType?.attribute
                                  )) &&
                                el[0] === "y_series_2") ||
                              (seriesBg &&
                                [
                                  "bar",
                                  "horizontal-bar",
                                  "lollipop",
                                  "area",
                                  "line",
                                  "scatter",
                                  "quadrant",
                                  "multilayer-map",
                                ]?.includes(axisPanelAtt?.chart_type) &&
                                el[0] === "y_series_1" &&
                                Object?.keys(axisPanelAtt?.y_axis)?.length ==
                                  1 &&
                                (axisPanelAtt?.dragDataType?.attribute ===
                                  "nss" ||
                                  axisPanelAtt?.dragDataType?.attribute ===
                                    "srs") &&
                                "0 0.2rem 0.5rem rgb(103 139 255 / 50%)") ||
                              (seriesBg &&
                                axisPanelAtt?.dragDataType?.attribute !==
                                  "nss" &&
                                axisPanelAtt?.dragDataType?.attribute !==
                                  "srs" &&
                                `0 0.2rem 0.5rem ${
                                  authParams?.theme_type === "1"
                                    ? "#fff"
                                    : "rgb(103 139 255 / 50%)"
                                }`),

                            backgroundColor:
                              authParams?.theme_type === "1"
                                ? ""
                                : !el[1]?.attribute
                                ? "#F2F7FF"
                                : "#FFFFFF",
                          }}
                          onChange={handleInput}
                        >
                          {!axisPanelAtt?.y_axis[el[0]]?.attribute ? ( // addtional y-series is empty
                            <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                              Drag fields here
                            </span>
                          ) : (
                            <span
                              className="cursor-pointer p-2 text-ellipsis d-flex align-items-center justify-content-between"
                              onClick={(e) =>
                                openEditFields({
                                  // when additional y-series not empty
                                  series: el[0],
                                  attName:
                                    axisPanelAtt?.y_axis[el[0]]?.attribute,
                                  agg: axisPanelAtt?.y_axis[el[0]]?.aggregation,
                                  seriesColor:
                                    axisPanelAtt?.y_axis[el[0]]?.color,
                                  chart_type: chart_type,
                                  event: e,
                                  info_text:
                                    axisPanelAtt?.y_axis[el[0]]?.info_text,
                                })
                              }
                              style={{ width: "90%" }}
                            >
                              <span>
                                <Tooltip
                                  title={
                                    All_WM_attributes[
                                      axisPanelAtt?.y_axis?.[el?.[0]]?.attribute
                                    ]
                                  }
                                >
                                  {All_WM_attributes[
                                    axisPanelAtt?.y_axis?.[el?.[0]]?.attribute
                                  ]?.length > 17
                                    ? All_WM_attributes[
                                        axisPanelAtt?.y_axis?.[el?.[0]]
                                          ?.attribute
                                      ]?.substr(0, 17) + " ..."
                                    : All_WM_attributes[
                                        axisPanelAtt?.y_axis?.[el?.[0]]
                                          ?.attribute
                                      ]}
                                </Tooltip>
                                {axisPanelAtt?.y_axis[el[0]]?.filters
                                  ?.length ? (
                                  <Tooltip
                                    placement="leftTop"
                                    overlayStyle={{
                                      width: widgetGraphConfig?.filters?.length
                                        ? "22rem"
                                        : "15rem",
                                    }}
                                    color="#3B5175"
                                    title={
                                      <>
                                        <div
                                          className="custom_scroll"
                                          style={{
                                            maxWidth: "27rem",
                                            maxHeight: "23rem",
                                            overflow: "auto",
                                            scrollBehavior: "smooth",
                                          }}
                                        >
                                          {axisPanelAtt?.y_axis[el[0]]?.filters
                                            ?.length
                                            ? axisPanelAtt?.y_axis[
                                                el[0]
                                              ]?.filters?.map((el) => {
                                                return (
                                                  el?.attribute !== "brandid" &&
                                                  el?.attribute !==
                                                    "createddate" && (
                                                    <div className="mb-2">
                                                      <p className="mb-0 text-white">
                                                        <strong>
                                                          {el?.attribute ===
                                                          "brandid"
                                                            ? "Brands"
                                                            : All_WM_attributes &&
                                                              All_WM_attributes[
                                                                el?.attribute
                                                              ]
                                                            ? All_WM_attributes[
                                                                el?.attribute
                                                              ]
                                                            : el?.attribute?.toLowerCase() ===
                                                              "categoryid"
                                                            ? "Category"
                                                            : el?.attribute?.toLowerCase() ===
                                                              "subcategoryid_aug"
                                                            ? "Sub Category"
                                                            : el?.attribute?.toLowerCase() ===
                                                              "subsubcategoryid"
                                                            ? "Sub Sub Category"
                                                            : el?.attribute?.replace(
                                                                "Type",
                                                                ""
                                                              )}
                                                        </strong>
                                                      </p>
                                                      {el?.type === "int" &&
                                                        !Array.isArray(
                                                          el?.columns
                                                        ) && (
                                                          <span className="font-weight-light text-white">
                                                            {el?.columns?.from +
                                                              " - " +
                                                              el?.columns?.to}
                                                          </span>
                                                        )}
                                                      {el?.attribute ===
                                                      "createddate" ? (
                                                        <span
                                                          className="font-weight-light"
                                                          style={{
                                                            color: "#fff",
                                                          }}
                                                        >
                                                          {`${el?.columns?.from} - ${el?.columns?.to}`}
                                                        </span>
                                                      ) : (
                                                        Array.isArray(
                                                          el?.columns
                                                        ) &&
                                                        el?.columns?.map(
                                                          (e, index) => {
                                                            return (
                                                              <span
                                                                className="font-weight-light"
                                                                style={{
                                                                  color:
                                                                    e?.type ===
                                                                    "include"
                                                                      ? "#5ed66d"
                                                                      : e?.type ===
                                                                        "exclude"
                                                                      ? "#fb7665"
                                                                      : "#fff",
                                                                }}
                                                              >
                                                                {(index
                                                                  ? ", "
                                                                  : "") +
                                                                  (e?.display_name
                                                                    ? e?.display_name
                                                                    : e?.name ===
                                                                      null
                                                                    ? "Any"
                                                                    : e?.name ===
                                                                      0
                                                                    ? "No"
                                                                    : e?.name ===
                                                                      1
                                                                    ? "Yes"
                                                                    : e?.name)}
                                                              </span>
                                                            );
                                                          }
                                                        )
                                                      )}
                                                    </div>
                                                  )
                                                );
                                              })
                                            : ` `}
                                        </div>
                                      </>
                                    }
                                  >
                                    <Space size="small">
                                      <Badge
                                        style={{
                                          backgroundColor: "#185edf",
                                          fontSize: "1rem",
                                          marginLeft: "1rem",
                                        }}
                                        title=""
                                        size="small"
                                        count={
                                          axisPanelAtt?.y_axis[el[0]]?.filters
                                            ?.length
                                            ? axisPanelAtt?.y_axis[el[0]]
                                                ?.filters?.length
                                            : 0
                                        }
                                      ></Badge>
                                    </Space>
                                  </Tooltip>
                                ) : (
                                  ""
                                )}
                              </span>
                              <Tooltip title={"Attribute Configuration"}>
                                {" "}
                                <img
                                  src={
                                    authParams?.theme_type === "1"
                                      ? SettingsLogo
                                      : SettingLogoHover
                                  }
                                  alt="arrow"
                                  className="accordionArrow"
                                  style={{
                                    transform: `rotate("180deg")`,
                                  }}
                                />
                              </Tooltip>
                            </span>
                          )}
                          {axisPanelAtt?.y_axis[el[0]]?.attribute && (
                            <CloseIcon
                              onClick={() =>
                                deleteAxisAttribute(
                                  "y_axis",
                                  el[0],
                                  axisPanelAtt?.y_axis_settings[i]?.key
                                )
                              }
                              className="mr-2"
                            />
                          )}
                          {provided?.placeholder && (
                            <div className="droppable-placeholder">
                              {provided?.placeholder}
                            </div>
                          )}
                        </div>
                      )}
                    </Droppable>
                  </Content>
                </Layout>
              );
            })
          : [
              "horizontal-bar",
              "lollipop",
              "bubble",
              "bar",
              "area",
              "heatmap",
              "sankey",
              "sunburst",
              "quadrant",
              "pie",
              "donut",
              "kpi",
              "progress-kpi",
              "map",
              "wordcloud",
            ]?.includes(chart_type) && (
              <Layout className="mt-3 bg-white">
                <Content>
                  <div className="text_regular font-weight600">
                    {[
                      "kpi",
                      "progress-kpi",
                      "map",
                      "pie",
                      "donut",
                      "wordcloud",
                    ]?.includes(chart_type)
                      ? "Values"
                      : "Y-series"}{" "}
                    <span className="error">*</span>
                  </div>
                  <Droppable droppableId="y_axis#y_series_1#values">
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center flex-wrap"
                        style={{
                          height: "4rem",
                          border: `0.1rem ${
                            !axisPanelAtt?.y_axis["y_series_1"]?.attribute
                              ? "dashed"
                              : "solid"
                          } ${
                            (axisPanelAtt?.dragDataType.int &&
                              (axisPanelAtt?.chart_type === "bubble" ||
                                axisPanelAtt?.chart_type === "heatmap" ||
                                axisPanelAtt?.chart_type === "sankey" ||
                                axisPanelAtt?.chart_type === "sunburst" ||
                                axisPanelAtt?.chart_type === "pie" ||
                                axisPanelAtt?.chart_type === "donut" ||
                                axisPanelAtt?.chart_type === "wordcloud" ||
                                axisPanelAtt?.chart_type === "map") &&
                              !graphConditions?.["time-label-attrs"]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              !graphConditions?.[
                                "ticket-time-label-attrs"
                              ]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                              axisPanelAtt?.dragDataType?.attribute !==
                                "srs") ||
                            (axisPanelAtt?.dragDataType?.int &&
                              (axisPanelAtt?.chart_type === "kpi" ||
                                chart_type === "progress-kpi") &&
                              axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                              axisPanelAtt?.dragDataType?.attribute !== "srs")
                              ? "#DDDDDD"
                              : !axisPanelAtt?.y_axis["y_series_1"]?.attribute
                              ? "#9CB4FF"
                              : "#d9e5ed"
                          }`,
                          boxShadow:
                            ((axisPanelAtt?.dragDataType.int &&
                              (axisPanelAtt?.chart_type === "bubble" ||
                                axisPanelAtt?.chart_type === "heatmap" ||
                                axisPanelAtt?.chart_type === "sankey" ||
                                axisPanelAtt?.chart_type === "sunburst" ||
                                axisPanelAtt?.chart_type === "pie" ||
                                axisPanelAtt?.chart_type === "donut" ||
                                axisPanelAtt?.chart_type === "wordcloud" ||
                                axisPanelAtt?.chart_type === "map") &&
                              !graphConditions?.["time-label-attrs"]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              !graphConditions?.[
                                "ticket-time-label-attrs"
                              ]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                              axisPanelAtt?.dragDataType?.attribute !==
                                "srs") ||
                              (axisPanelAtt?.dragDataType?.int &&
                                (axisPanelAtt?.chart_type === "kpi" ||
                                  chart_type === "progress-kpi") &&
                                axisPanelAtt?.dragDataType?.attribute !==
                                  "nss" &&
                                axisPanelAtt?.dragDataType?.attribute !==
                                  "srs")) &&
                            `0 0.2rem 0.5rem ${
                              authParams?.theme_type === "1"
                                ? "#fff"
                                : "rgb(103 139 255 / 50%)"
                            }`,

                          backgroundColor:
                            authParams?.theme_type === "1"
                              ? ""
                              : !axisPanelAtt?.y_axis?.["y_series_1"]?.attribute
                              ? "#F2F7FF"
                              : "#FFFFFF",
                        }}
                        onChange={handleInput}
                      >
                        {!axisPanelAtt?.y_axis["y_series_1"]?.attribute ? (
                          <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                            Drag fields here
                          </span>
                        ) : (
                          <span
                            className={`${
                              chart_type !== "map" && "cursor-pointer"
                            }  p-2 text-ellipsis`}
                            style={{ maxWidth: "90%" }}
                          >
                            <span>
                              <Tooltip
                                title={
                                  All_WM_attributes[
                                    axisPanelAtt?.y_axis["y_series_1"]
                                      ?.attribute
                                  ]
                                }
                              >
                                {All_WM_attributes[
                                  axisPanelAtt?.y_axis["y_series_1"]?.attribute
                                ]?.length > 17
                                  ? All_WM_attributes[
                                      axisPanelAtt?.y_axis["y_series_1"]
                                        ?.attribute
                                    ]?.substr(0, 17) + " ..."
                                  : All_WM_attributes[
                                      axisPanelAtt?.y_axis["y_series_1"]
                                        ?.attribute
                                    ]}
                              </Tooltip>
                              {axisPanelAtt?.y_axis["y_series_1"]?.filters
                                ?.length ? (
                                <Tooltip
                                  placement="leftTop"
                                  overlayStyle={{
                                    width: widgetGraphConfig?.filters?.length
                                      ? "22rem"
                                      : "15rem",
                                  }}
                                  color="#3B5175"
                                  title={
                                    <>
                                      <div
                                        className="custom_scroll"
                                        style={{
                                          maxWidth: "27rem",
                                          maxHeight: "23rem",
                                          overflow: "auto",
                                          scrollBehavior: "smooth",
                                        }}
                                      >
                                        {axisPanelAtt?.y_axis["y_series_1"]
                                          ?.filters?.length
                                          ? axisPanelAtt?.y_axis[
                                              "y_series_1"
                                            ]?.filters?.map((el) => {
                                              return (
                                                el?.attribute !== "brandid" &&
                                                el?.attribute !==
                                                  "createddate" && (
                                                  <div className="mb-2">
                                                    <p className="mb-0 text-white">
                                                      <strong>
                                                        {el?.attribute ===
                                                        "brandid"
                                                          ? "Brands"
                                                          : All_WM_attributes &&
                                                            All_WM_attributes[
                                                              el?.attribute
                                                            ]
                                                          ? All_WM_attributes[
                                                              el?.attribute
                                                            ]
                                                          : el?.attribute?.toLowerCase() ===
                                                            "categoryid"
                                                          ? "Category"
                                                          : el?.attribute?.toLowerCase() ===
                                                            "subcategoryid_aug"
                                                          ? "Sub Category"
                                                          : el?.attribute?.toLowerCase() ===
                                                            "subsubcategoryid"
                                                          ? "Sub Sub Category"
                                                          : el?.attribute?.replace(
                                                              "Type",
                                                              ""
                                                            )}
                                                      </strong>
                                                    </p>
                                                    {el?.type === "int" &&
                                                      !Array.isArray(
                                                        el?.columns
                                                      ) && (
                                                        <span className="font-weight-light text-white">
                                                          {el?.columns?.from +
                                                            " - " +
                                                            el?.columns?.to}
                                                        </span>
                                                      )}
                                                    {el?.attribute ===
                                                    "createddate" ? (
                                                      <span
                                                        className="font-weight-light"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                      >
                                                        {`${el?.columns?.from} - ${el?.columns?.to}`}
                                                      </span>
                                                    ) : (
                                                      Array.isArray(
                                                        el?.columns
                                                      ) &&
                                                      el?.columns?.map(
                                                        (e, index) => {
                                                          return (
                                                            <span
                                                              className="font-weight-light"
                                                              style={{
                                                                color:
                                                                  e?.type ===
                                                                  "include"
                                                                    ? "#5ed66d"
                                                                    : e?.type ===
                                                                      "exclude"
                                                                    ? "#fb7665"
                                                                    : "#fff",
                                                              }}
                                                            >
                                                              {(index
                                                                ? ", "
                                                                : "") +
                                                                (e?.display_name
                                                                  ? e?.display_name
                                                                  : e?.name ===
                                                                    null
                                                                  ? "Any"
                                                                  : e?.name ===
                                                                    0
                                                                  ? "No"
                                                                  : e?.name ===
                                                                    1
                                                                  ? "Yes"
                                                                  : e?.name)}
                                                            </span>
                                                          );
                                                        }
                                                      )
                                                    )}
                                                  </div>
                                                )
                                              );
                                            })
                                          : ` `}
                                      </div>
                                    </>
                                  }
                                >
                                  <Space size="small">
                                    <Badge
                                      style={{
                                        backgroundColor: "#185edf",
                                        fontSize: "1rem",
                                        marginLeft: "1rem",
                                      }}
                                      title=""
                                      size="small"
                                      count={
                                        axisPanelAtt?.y_axis["y_series_1"]
                                          ?.filters?.length
                                          ? axisPanelAtt?.y_axis["y_series_1"]
                                              ?.filters?.length
                                          : 0
                                      }
                                    ></Badge>
                                  </Space>
                                </Tooltip>
                              ) : (
                                ""
                              )}
                            </span>
                          </span>
                        )}
                        {axisPanelAtt?.y_axis["y_series_1"]?.attribute && (
                          <div
                            className="d-flex flex-row"
                            style={{
                              gap: "0.8rem",
                              alignItems: "center",
                            }}
                          >
                            <Tooltip title={"Attribute Configuration"}>
                              {" "}
                              <img
                                onClick={(e) =>
                                  chart_type !== "map" &&
                                  openEditFields({
                                    series: "y_series_1",
                                    attName:
                                      axisPanelAtt?.y_axis["y_series_1"]
                                        ?.attribute,
                                    agg: axisPanelAtt?.y_axis["y_series_1"]
                                      ?.aggregation,
                                    seriesColor:
                                      axisPanelAtt?.y_axis["y_series_1"]?.color,
                                    chart_type: chart_type,
                                    event: e,
                                    info_text:
                                      axisPanelAtt?.y_axis["y_series_1"]
                                        ?.info_text,
                                  })
                                }
                                src={
                                  authParams?.theme_type === "1"
                                    ? SettingsLogo
                                    : SettingLogoHover
                                }
                                alt="arrow"
                                className="accordionArrow cursor-pointer"
                                style={{
                                  transform: `rotate("180deg")`,
                                }}
                              />
                            </Tooltip>
                            <CloseIcon
                              className="mr-2"
                              onClick={() =>
                                deleteAxisAttribute("y_axis", "y_series_1")
                              }
                            />
                          </div>
                        )}
                        {provided?.placeholder && (
                          <div className="droppable-placeholder">
                            {provided?.placeholder}
                          </div>
                        )}
                      </div>
                    )}
                  </Droppable>
                </Content>
              </Layout>
            )}
        {axisPanelAtt &&
        (axisPanelAtt?.y_axis?.y_series_1?.attribute === "nss" ||
          axisPanelAtt?.y_axis?.y_series_1?.attribute === "srs" ||
          (axisPanelAtt?.y_axis?.y_series_1?.attribute &&
            graphConditions?.common
              ?.map((d) => d?.attribute)
              ?.includes(axisPanelAtt?.y_axis?.y_series_1?.attribute)))
          ? ""
          : [
              "combination",
              "line",
              "horizontal-bar",
              "lollipop",
              "bar",
              "area",
              "scatter",
              "multilayer-map",
            ]?.includes(chart_type) && // enabling multiple y-series for these charts
            (["scatter", "multilayer-map"]?.includes(chart_type)
              ? Object.keys(axisPanelAtt?.y_axis).length < 2 // adding limit of 2 on y-series for scatter chart
              : Object.keys(axisPanelAtt?.y_axis).length < 10) && // adding limit of 10 on y-series
            Object.values(axisPanelAtt?.y_axis)[
              Object?.keys(axisPanelAtt?.y_axis)?.length - 1
            ]?.attribute && (
              <p
                onClick={() => handleAddYSeries("y_axis")}
                className="mt-2 cursor-pointer"
                style={{
                  color: authParams?.theme_type === "1" ? "#678BFF" : "#185EDF",
                }}
              >
                + Add another Y-series
              </p>
            )}
        {chart_type === "sankey" && axisPanelAtt?.breakdown_by?.length >= 1 ? ( // sankey chart breakdown by
          Object.entries(axisPanelAtt?.breakdown_by).map((el, i) => {
            let showAddBreakdownBy = false;
            if (i === axisPanelAtt?.breakdown_by.length - 1) {
              showAddBreakdownBy = true;
            }
            return (
              <Layout className="mt-3 bg-white " index={i}>
                <Content>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="text_regular font-weight600">
                      {`Breakdown By ${i + 1}`}
                    </div>
                    {i > 0 && (
                      <span
                        onClick={() => removeBreakdownBy(axisPanelAtt, i)} // to remove additional breakdown by
                        style={{
                          color:
                            authParams?.theme_type === "1"
                              ? "#678BFF"
                              : "#185EDF",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </span>
                    )}
                  </div>
                  <Droppable droppableId={`breakdown_by#${i}`}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                        style={{
                          border: `0.1rem ${
                            !axisPanelAtt?.breakdown_by?.length > 0
                              ? "dashed"
                              : "solid"
                          } ${
                            (chart_type === "wordcloud" ||
                              chart_type === "bubble" ||
                              chart_type === "heatmap" ||
                              chart_type === "sankey" ||
                              chart_type === "sunburst") &&
                            axisPanelAtt?.dragDataType?.attribute === "Rating"
                              ? "#9CB4FF"
                              : !nssCase &&
                                axisPanelAtt?.dragDataType?.varchar &&
                                axisPanelAtt?.x_axis?.attribute !==
                                  axisPanelAtt?.dragDataType?.attribute
                              ? "#DDDDDD"
                              : !axisPanelAtt?.breakdown_by?.length > 0
                              ? "#9CB4FF"
                              : "#d9e5ed"
                          }`,
                          boxShadow: "rgb(103 139 255 / 50%)",

                          backgroundColor:
                            authParams?.theme_type === "1"
                              ? ""
                              : !axisPanelAtt?.breakdown_by[i]?.attribute
                              ? "#F2F7FF"
                              : "#FFFFFF",
                        }}
                        onChange={handleInput}
                      >
                        {!axisPanelAtt?.breakdown_by[i]?.attribute ? (
                          <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                            Drag fields here
                          </span>
                        ) : (
                          <span
                            className="cursor-pointer p-2 d-flex align-items-center justify-content-between"
                            onClick={(e) =>
                              openEditFields({
                                series: "breakdown",
                                attName:
                                  axisPanelAtt?.breakdown_by[i]?.attribute,
                                date_part:
                                  axisPanelAtt?.breakdown_by[i]?.date_part,
                                y_limit: axisPanelAtt?.breakdown_by[i]?.y_limit,
                                chart_type: chart_type,
                                breakdown_index: i,
                                is_pivot:
                                  axisPanelAtt?.breakdown_by[i]?.is_pivot,
                                seriesColor:
                                  axisPanelAtt?.breakdown_by[i]?.color,
                                event: e,
                              })
                            }
                            style={{ width: "90%" }}
                          >
                            <span className="text-ellipsis">
                              <Tooltip
                                title={
                                  All_WM_attributes[
                                    axisPanelAtt?.breakdown_by?.[i]?.attribute
                                  ]
                                }
                              >
                                {All_WM_attributes[
                                  axisPanelAtt?.breakdown_by?.[i]?.attribute
                                ]?.length > 17
                                  ? All_WM_attributes[
                                      axisPanelAtt?.breakdown_by?.[i]?.attribute
                                    ]?.substr(0, 17) + " ..."
                                  : All_WM_attributes[
                                      axisPanelAtt?.breakdown_by?.[i]?.attribute
                                    ]}
                              </Tooltip>
                            </span>
                            <Tooltip title={"Attribute Configuration"}>
                              {" "}
                              <img
                                src={
                                  authParams?.theme_type === "1"
                                    ? SettingsLogo
                                    : SettingLogoHover
                                }
                                alt="arrow"
                                className="accordionArrow"
                                style={{
                                  transform: `rotate("180deg")`,
                                }}
                              />
                            </Tooltip>
                          </span>
                        )}
                        {widgetGraphConfig?.y_axis?.y_series_1?.attribute !==
                          "srs" &&
                          axisPanelAtt?.breakdown_by?.length > 0 && (
                            <CloseIcon
                              className="mr-2"
                              onClick={() =>
                                deleteAxisAttribute("breakdown_by", "sankey", i)
                              }
                            />
                          )}
                        {provided?.placeholder && (
                          <div className="droppable-placeholder">
                            {provided?.placeholder}
                          </div>
                        )}
                      </div>
                    )}
                  </Droppable>
                </Content>
                {axisPanelAtt && // adding mulitple breakdownBy
                (axisPanelAtt?.y_axis?.y_series_1?.attribute === "nss" ||
                  axisPanelAtt?.y_axis?.y_series_1?.attribute === "srs")
                  ? ""
                  : chart_type === "sankey" &&
                    Object.keys(axisPanelAtt?.breakdown_by).length < 10 && // adding limit of 10 on y-series
                    Object.values(axisPanelAtt?.breakdown_by)[
                      Object?.keys(axisPanelAtt?.breakdown_by)?.length - 1
                    ]?.attribute &&
                    showAddBreakdownBy && (
                      <p
                        onClick={() => handleAddBreakdownBy("breakdown_by")}
                        className="mt-2 cursor-pointer"
                        style={{
                          color:
                            authParams?.theme_type === "1"
                              ? "#678BFF"
                              : "#185EDF",
                        }}
                      >
                        + Add another Breakdown By
                      </p>
                    )}
              </Layout>
            );
          })
        ) : chart_type === "sankey" && !axisPanelAtt?.breakdown_by?.length ? (
          <Content className="mt-3">
            <div className="text_regular font-weight600">Breakdown By</div>
            <Droppable droppableId={`breakdown_by#0`}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                  style={{
                    border: `0.1rem ${
                      !axisPanelAtt?.breakdown_by?.length > 0
                        ? "dashed"
                        : "solid"
                    } ${
                      axisPanelAtt?.dragDataType?.attribute === "Rating"
                        ? "#9CB4FF"
                        : !nssCase &&
                          axisPanelAtt?.dragDataType?.varchar &&
                          axisPanelAtt?.x_axis?.attribute !==
                            axisPanelAtt?.dragDataType?.attribute
                        ? "#DDDDDD"
                        : !axisPanelAtt?.breakdown_by?.length > 0
                        ? "#9CB4FF"
                        : "#d9e5ed"
                    }`,
                    boxShadow:
                      (chart_type === "wordcloud" ||
                        chart_type === "bubble" ||
                        chart_type === "heatmap" ||
                        chart_type === "sankey" ||
                        chart_type === "sunburst") &&
                      axisPanelAtt?.dragDataType?.attribute === "Rating"
                        ? null
                        : !nssCase &&
                          ((axisPanelAtt?.dragDataType?.varchar &&
                            axisPanelAtt?.x_axis?.attribute !==
                              axisPanelAtt?.dragDataType?.attribute) ||
                            (axisPanelAtt?.dragDataType?.datetime &&
                              [
                                "combination",
                                "bar",
                                "horizontal-bar",
                                "lollipop",
                                "area",
                                "line",
                                "pie",
                                "donut",
                                "scatter",
                                "quadrant",
                                "multilayer-map",
                              ]?.includes(chart_type))) &&
                          `0 0.2rem 0.5rem ${
                            authParams?.theme_type === "1"
                              ? "#fff"
                              : "rgb(103 139 255 / 50%)"
                          }`,

                    backgroundColor:
                      authParams?.theme_type === "1"
                        ? ""
                        : !axisPanelAtt?.breakdown_by?.length > 0
                        ? "#F2F7FF"
                        : "#FFFFFF",
                  }}
                  onChange={handleInput}
                >
                  {!axisPanelAtt?.breakdown_by?.length > 0 ? (
                    <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                      Drag fields here
                    </span>
                  ) : (
                    <span
                      className="cursor-pointer p-2 d-flex align-items-center justify-content-between"
                      onClick={(e) =>
                        openEditFields({
                          series: "breakdown",
                          attName: axisPanelAtt?.breakdown_by[0]?.attribute,
                          date_part: axisPanelAtt?.breakdown_by[0]?.date_part,
                          y_limit: axisPanelAtt?.breakdown_by[0]?.y_limit,
                          chart_type: chart_type,
                          percent: null,
                          breakdown_index: 0,
                          is_pivot: axisPanelAtt?.breakdown_by[0]?.is_pivot,
                          seriesColor: axisPanelAtt?.breakdown_by[0]?.color,
                          event: e,
                        })
                      }
                      style={{ width: "90%" }}
                    >
                      <span className="text-ellipsis">
                        <Tooltip
                          title={
                            All_WM_attributes[
                              axisPanelAtt?.breakdown_by?.[0]?.attribute
                            ]
                          }
                        >
                          {All_WM_attributes[
                            axisPanelAtt?.breakdown_by?.[0]?.attribute
                          ]?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.breakdown_by?.[0]?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.breakdown_by?.[0]?.attribute
                              ]}
                        </Tooltip>
                      </span>
                      <Tooltip title={"Attribute Configuration"}>
                        {" "}
                        <img
                          src={
                            authParams?.theme_type === "1"
                              ? SettingsLogo
                              : SettingLogoHover
                          }
                          alt="arrow"
                          className="accordionArrow"
                          style={{
                            transform: `rotate("180deg")`,
                          }}
                        />
                      </Tooltip>
                    </span>
                  )}
                  {widgetGraphConfig?.y_axis?.y_series_1?.attribute !== "srs" &&
                    axisPanelAtt?.breakdown_by?.length > 0 && (
                      <CloseIcon
                        onClick={() => deleteAxisAttribute("breakdown_by")}
                        className="mr-2"
                      />
                    )}
                  {provided?.placeholder && (
                    <div className="droppable-placeholder">
                      {provided?.placeholder}
                    </div>
                  )}
                </div>
              )}
            </Droppable>
          </Content>
        ) : (
          ""
        )}
        {[
          // breakdown by start
          "combination",
          "bar",
          "horizontal-bar",
          "lollipop",
          "area",
          "line",
          "bubble",
          "heatmap",
          "sunburst",
          "scatter",
          "quadrant",
          "multilayer-map",
        ]?.includes(chart_type) &&
          enableBreakdownBy && (
            <Layout className="bg-white">
              <Content className="mt-3">
                <div className="text_regular font-weight600">
                  Breakdown By&nbsp;
                  {(chart_type === "bubble" ||
                    chart_type === "heatmap" ||
                    chart_type === "sankey" ||
                    chart_type === "sunburst") && (
                    <>
                      <span className="error">*</span>
                    </>
                  )}
                </div>
                <Droppable droppableId="breakdown_by">
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                      style={{
                        border: `1px ${
                          !axisPanelAtt?.breakdown_by?.length > 0
                            ? "dashed"
                            : "solid"
                        } ${
                          (chart_type === "wordcloud" ||
                            chart_type === "bubble" ||
                            chart_type === "heatmap" ||
                            chart_type === "sankey" ||
                            chart_type === "sunburst") &&
                          axisPanelAtt?.dragDataType?.attribute === "Rating"
                            ? "#9CB4FF"
                            : !nssCase &&
                              axisPanelAtt?.dragDataType?.varchar &&
                              axisPanelAtt?.x_axis?.attribute !==
                                axisPanelAtt?.dragDataType?.attribute
                            ? "#DDDDDD"
                            : !axisPanelAtt?.breakdown_by?.length > 0
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        boxShadow:
                          (chart_type === "wordcloud" ||
                            chart_type === "bubble" ||
                            chart_type === "heatmap" ||
                            chart_type === "sankey" ||
                            chart_type === "sunburst") &&
                          axisPanelAtt?.dragDataType?.attribute === "Rating"
                            ? null
                            : !nssCase &&
                              ((axisPanelAtt?.dragDataType?.varchar &&
                                axisPanelAtt?.x_axis?.attribute !==
                                  axisPanelAtt?.dragDataType?.attribute) ||
                                (axisPanelAtt?.dragDataType?.datetime &&
                                  [
                                    "combination",
                                    "bar",
                                    "horizontal-bar",
                                    "lollipop",
                                    "area",
                                    "line",
                                    "pie",
                                    "donut",
                                    "scatter",
                                    "quadrant",
                                  ]?.includes(chart_type))) &&
                              `0 2px 5px ${
                                authParams?.theme_type === "1"
                                  ? "#fff"
                                  : "rgb(103 139 255 / 50%)"
                              }`,

                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : !axisPanelAtt?.breakdown_by?.length > 0
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                      onChange={handleInput}
                    >
                      {!axisPanelAtt?.breakdown_by?.length > 0 ? (
                        <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                          Drag fields here
                        </span>
                      ) : (
                        <span
                          className="cursor-pointer p-2 d-flex align-items-center justify-content-between"
                          onClick={(e) =>
                            openEditFields({
                              series: "breakdown",
                              attName: axisPanelAtt?.breakdown_by[0]?.attribute,
                              date_part:
                                axisPanelAtt?.breakdown_by[0]?.date_part,
                              y_limit: axisPanelAtt?.breakdown_by[0]?.y_limit,
                              chart_type: chart_type,
                              breakdown_index: 0,
                              is_pivot: axisPanelAtt?.breakdown_by[0]?.is_pivot,
                              seriesColor: axisPanelAtt?.breakdown_by[0]?.color,
                              event: e,
                            })
                          }
                          style={{ width: "90%" }}
                        >
                          <span className="text-ellipsis">
                            <Tooltip
                              title={
                                All_WM_attributes[
                                  axisPanelAtt?.breakdown_by?.[0]?.attribute
                                ]
                              }
                            >
                              {All_WM_attributes[
                                axisPanelAtt?.breakdown_by?.[0]?.attribute
                              ]?.length > 17
                                ? All_WM_attributes[
                                    axisPanelAtt?.breakdown_by?.[0]?.attribute
                                  ]?.substr(0, 17) + " ..."
                                : All_WM_attributes[
                                    axisPanelAtt?.breakdown_by?.[0]?.attribute
                                  ]}
                            </Tooltip>
                          </span>
                          <Tooltip title={"Attribute Configuration"}>
                            {" "}
                            <img
                              src={
                                authParams?.theme_type === "1"
                                  ? SettingsLogo
                                  : SettingLogoHover
                              }
                              alt="arrow"
                              className="accordionArrow"
                              style={{
                                transform: `rotate("180deg")`,
                              }}
                            />
                          </Tooltip>
                        </span>
                      )}
                      {widgetGraphConfig?.y_axis?.y_series_1?.attribute !==
                        "srs_temp" &&
                        axisPanelAtt?.breakdown_by?.length > 0 && (
                          <CloseIcon
                            onClick={() => deleteAxisAttribute("breakdown_by")}
                            className="mr-2"
                          />
                        )}
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            </Layout>
          )}
        {/* Field for Network Graph Chart */}
        {chart_type === "network-graph" || chart_type === "network-graph-v2" ? (
          <>
            <div className="text_regular font-weight600 mt-3">
              Node {`${1}`} <span className="error">*</span>
            </div>

            <div className="border border-color p-1">
              <Layout className="bg-white">
                {axisPanelAtt?.x_axis ? (
                  <Content className="mt-1">
                    <Droppable droppableId={`x_axis`}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="border-radius-4 text_regular d-flex justify-content-between align-items-center"
                          style={{
                            height: "40px",
                            border: "1px solid #C3CBD7",
                            backgroundColor:
                              authParams?.theme_type === "1" ? "" : "#FFFFFF",
                          }}
                        >
                          <span
                            className="cursor-pointer p-2 w-100 text_regular text-ellipsis"
                            onClick={(e) =>
                              openEditFields({
                                series: "x_axis",
                                attName: axisPanelAtt?.x_axis?.attribute,
                                agg: axisPanelAtt?.x_axis?.aggregation,
                                x_limit: axisPanelAtt?.x_axis?.x_limit,
                                date_part: axisPanelAtt?.x_axis?.date_part,
                                chart_type: chart_type,
                                event: e,
                                radius_attribute:
                                  axisPanelAtt?.x_axis?.radius_attribute,
                                seriesColor: axisPanelAtt?.x_axis?.color,
                              })
                            }
                          >
                            <Tooltip
                              title={
                                All_WM_attributes[
                                  axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                                ]
                              }
                            >
                              {All_WM_attributes[
                                axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                              ]?.length > 17
                                ? All_WM_attributes[
                                    axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                                  ]?.substr(0, 17) + " ..."
                                : All_WM_attributes[
                                    axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                                  ]}
                            </Tooltip>
                          </span>
                          <CloseIcon
                            className="mr-2"
                            onClick={() => deleteAxisAttribute("x_axis")}
                          />
                        </div>
                      )}
                    </Droppable>
                  </Content>
                ) : (
                  <Content className="mt-2">
                    <Droppable droppableId={`x_axis`}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="cursor-pointer border-radius-4 p-2 w-100 text-center text_regular text-ellipsis"
                          style={{
                            height: "40px",
                            border: `1px ${totalLength ? "dashed" : "solid"} ${
                              axisPanelAtt?.dragDataType?.varchar
                                ? "#DDDDDD"
                                : totalLength
                                ? "#9CB4FF"
                                : "#d9e5ed"
                            }`,
                            boxShadow:
                              chart_type === "grid"
                                ? axisPanelAtt?.breakdown_by?.length < 2
                                : axisPanelAtt?.breakdown_by?.length < 1 &&
                                  (axisPanelAtt?.dragDataType?.varchar ||
                                    axisPanelAtt?.dragDataType?.int) &&
                                  axisPanelAtt?.dragDataType?.attribute !==
                                    "nss" &&
                                  axisPanelAtt?.dragDataType?.attribute !==
                                    "srs" &&
                                  !graphConditions?.[
                                    "time-label-attrs"
                                  ]?.includes(
                                    axisPanelAtt?.dragDataType?.attribute
                                  ) &&
                                  y_series_array_drag?.includes(
                                    axisPanelAtt?.dragDataType?.attribute
                                  ) &&
                                  `0 2px 5px ${
                                    authParams?.theme_type === "1"
                                      ? "#fff"
                                      : "rgb(103 139 255 / 50%)"
                                  }`,

                            backgroundColor:
                              authParams?.theme_type === "1"
                                ? ""
                                : totalLength
                                ? "#F2F7FF"
                                : "#FFFFFF",
                          }}
                        >
                          <span>Drop fields here</span>
                        </div>
                      )}
                    </Droppable>
                  </Content>
                )}
              </Layout>

              {networkGraphOptions && networkGraphOptions?.length > 0 ? (
                <Select
                  className="w-100 mt-1"
                  onChange={(value) => {
                    handleYSeriesAttributeChange(value, 0);
                  }}
                  dropdownClassName={
                    authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
                  }
                  placeholder={"Select Series"}
                  value={
                    Object.entries(axisPanelAtt?.y_axis)?.[0]?.[1]?.attribute
                      ? Object.entries(axisPanelAtt?.y_axis)?.[0]?.[1]
                          ?.attribute
                      : null
                  }
                >
                  {networkGraphOptions
                    ?.map((op) => {
                      if (
                        axisPanelAtt?.x_axis?.attribute &&
                        graphConditions?.["network-graph"]?.int?.exclude?.[
                          axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                        ]
                          ? !graphConditions?.["network-graph"]?.int?.exclude?.[
                              axisPanelAtt?.x_axis?.attribute?.toLowerCase()
                            ]?.includes(op?.attribute)
                          : true
                      ) {
                        return (
                          <Option value={op?.attribute}>
                            {op?.trace_name}
                          </Option>
                        );
                      } else {
                        return null;
                      }
                    })
                    ?.filter((e) => e)}
                </Select>
              ) : (
                ""
              )}
            </div>
            {/* {Object.entries(axisPanelAtt?.y_axis)} */}
            {Object.entries(axisPanelAtt?.y_axis)?.map((el, i) => {
              let splitHeading = el[0].split("_");
              let finalHeading = `${splitHeading[0].toUpperCase()}-${
                splitHeading[1]
              } ${splitHeading[2]}`;
              // if (
              //   !(
              //     axisPanelAtt?.breakdown_by?.length === 0 &&
              //     Object.entries(axisPanelAtt?.y_axis)?.length >
              //       axisPanelAtt?.breakdown_by?.length + 1
              //   ) ||
              //   (axisPanelAtt?.breakdown_by?.length > 0 &&
              //     axisPanelAtt?.breakdown_by?.length ===
              //       Object.entries(axisPanelAtt?.y_axis)?.length - 2)
              // ) {
              //   return;
              // }
              // This used temprarly to hide , adding node funtionality after two node
              if (i > 0) {
                return;
              }
              return (
                <>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div className="text_regular font-weight600 ">
                      Node {`${i + 2}`}{" "}
                      {(i === 0 ||
                        !el?.attribute ||
                        ((chart_type === "network-graph" ||
                          chart_type === "network-graph-v2") &&
                          i <= 1)) && <span className="error">*</span>}
                    </div>
                    {i > 0 &&
                      axisPanelAtt?.breakdown_by?.length > 0 &&
                      axisPanelAtt?.breakdown_by[i]?.attribute && (
                        <span
                          onClick={() =>
                            removeNode(
                              i,
                              axisPanelAtt?.breakdown_by?.length > 0 &&
                                axisPanelAtt?.breakdown_by[i]?.attribute
                            )
                          }
                          style={{
                            color:
                              authParams?.theme_type === "1"
                                ? "#678BFF"
                                : "#185EDF",
                            cursor: "pointer",
                          }}
                        >
                          {(chart_type === "network-graph" ||
                            chart_type === "network-graph-v2") &&
                          i === 0 ? (
                            ""
                          ) : (
                            <>Remove {`Node ${i + 2}`}</>
                          )}
                        </span>
                      )}
                  </div>
                  <div className="border border-color p-1">
                    <Layout className="bg-white " index={i + 1}>
                      <Content>
                        <Droppable
                          droppableId={`breakdown_by#nodes#attribute${
                            axisPanelAtt?.breakdown_by?.length > 0 &&
                            axisPanelAtt?.breakdown_by[i]?.attribute
                              ? `#update#${i}`
                              : `#${i}`
                          }`}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.droppableProps}
                              className="border-radius-4 text_regular d-flex justify-content-between align-items-center"
                              style={{
                                border: `1px ${
                                  !(
                                    axisPanelAtt?.breakdown_by?.length > 0 &&
                                    axisPanelAtt?.breakdown_by[i]?.attribute
                                  )
                                    ? "dashed"
                                    : "solid"
                                } ${
                                  (chart_type === "wordcloud" ||
                                    chart_type === "bubble" ||
                                    chart_type === "heatmap" ||
                                    chart_type === "sunburst") &&
                                  axisPanelAtt?.dragDataType?.attribute ===
                                    "rating"
                                    ? "#9CB4FF"
                                    : !nssCase &&
                                      axisPanelAtt?.dragDataType?.varchar &&
                                      axisPanelAtt?.x_axis?.attribute !==
                                        axisPanelAtt?.dragDataType?.attribute
                                    ? "#DDDDDD"
                                    : !(
                                        axisPanelAtt?.breakdown_by?.length >
                                          0 &&
                                        axisPanelAtt?.breakdown_by[i]?.attribute
                                      )
                                    ? "#9CB4FF"
                                    : "#d9e5ed"
                                }`,
                                boxShadow:
                                  (chart_type === "wordcloud" ||
                                    chart_type === "bubble" ||
                                    chart_type === "heatmap" ||
                                    chart_type === "sunburst") &&
                                  axisPanelAtt?.dragDataType?.attribute ===
                                    "rating"
                                    ? null
                                    : !nssCase &&
                                      ((axisPanelAtt?.dragDataType?.varchar &&
                                        axisPanelAtt?.x_axis?.attribute !==
                                          axisPanelAtt?.dragDataType
                                            ?.attribute) ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "combination") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "bar") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "horizontal-bar") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "area") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "line") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "pie") ||
                                        (axisPanelAtt?.dragDataType?.datetime &&
                                          chart_type === "donut")) &&
                                      `0 2px 5px ${
                                        authParams?.theme_type === "1"
                                          ? "#fff"
                                          : "rgb(103 139 255 / 50%)"
                                      }`,

                                backgroundColor:
                                  authParams?.theme_type === "1"
                                    ? ""
                                    : !(
                                        axisPanelAtt?.breakdown_by?.length >
                                          0 &&
                                        axisPanelAtt?.breakdown_by[i]?.attribute
                                      )
                                    ? "#F2F7FF"
                                    : "#FFFFFF",
                              }}
                              onChange={handleInput}
                            >
                              {!(
                                axisPanelAtt?.breakdown_by?.length > 0 &&
                                axisPanelAtt?.breakdown_by[i]?.attribute
                              ) ? (
                                <span className="cursor-pointer p-2 w-100 text-center text_regular">
                                  Drag fields here
                                </span>
                              ) : (
                                <span
                                  className="cursor-pointer p-2 d-flex align-items-center justify-content-between"
                                  onClick={(e) =>
                                    openEditFields({
                                      series: "breakdown",
                                      attName:
                                        axisPanelAtt?.breakdown_by[i]
                                          ?.attribute,
                                      date_part:
                                        axisPanelAtt?.breakdown_by[i]
                                          ?.date_part,
                                      y_limit:
                                        axisPanelAtt?.breakdown_by[i]?.y_limit,
                                      chart_type: chart_type,
                                      breakdown_index: i,
                                      is_pivot:
                                        axisPanelAtt?.breakdown_by[i]?.is_pivot,
                                      event: e,
                                      radius_attribute:
                                        axisPanelAtt?.breakdown_by[i]
                                          ?.radius_attribute,
                                      seriesColor:
                                        axisPanelAtt?.breakdown_by[i]?.color,
                                    })
                                  }
                                  style={{ width: "90%" }}
                                >
                                  <span className="text-ellipsis">
                                    <Tooltip
                                      title={
                                        All_WM_attributes[
                                          axisPanelAtt?.breakdown_by?.[
                                            i
                                          ]?.attribute?.toLowerCase()
                                        ]
                                      }
                                    >
                                      {All_WM_attributes[
                                        axisPanelAtt?.breakdown_by?.[
                                          i
                                        ]?.attribute?.toLowerCase()
                                      ]?.length > 17
                                        ? All_WM_attributes[
                                            axisPanelAtt?.breakdown_by?.[
                                              i
                                            ]?.attribute?.toLowerCase()
                                          ]?.substr(0, 17) + " ..."
                                        : All_WM_attributes[
                                            axisPanelAtt?.breakdown_by?.[
                                              i
                                            ]?.attribute?.toLowerCase()
                                          ]}
                                    </Tooltip>
                                  </span>
                                  <img
                                    src={
                                      authParams?.theme_type === "1"
                                        ? accoArrowWhite
                                        : accoArrow
                                    }
                                    alt="arrow"
                                    className="accordionArrow"
                                    style={{
                                      transform: `rotate("180deg")`,
                                    }}
                                  />
                                </span>
                              )}
                              {widgetGraphConfig?.y_axis?.y_series_1
                                ?.attribute !== "srs" &&
                                axisPanelAtt?.breakdown_by?.length > 0 &&
                                axisPanelAtt?.breakdown_by[i]?.attribute && (
                                  <CloseIcon
                                    onClick={() =>
                                      deleteAxisAttribute(
                                        "breakdown_by",
                                        null,
                                        i
                                      )
                                    }
                                    className="mr-2"
                                  />
                                )}
                            </div>
                          )}
                        </Droppable>
                      </Content>
                    </Layout>
                    {networkGraphOptions && networkGraphOptions?.length > 0 ? (
                      <Select
                        className="w-100 mt-1"
                        onChange={(value) => {
                          handleYSeriesAttributeChange(value, i + 1);
                        }}
                        dropdownClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme"
                            : "lightTheme"
                        }
                        placeholder={"Select Series"}
                        value={
                          Object.entries(axisPanelAtt?.y_axis)?.[i + 1]?.[1]
                            ?.attribute
                            ? Object.entries(axisPanelAtt?.y_axis)?.[i + 1]?.[1]
                                ?.attribute
                            : null
                        }
                      >
                        {networkGraphOptions?.map((op) => {
                          if (
                            axisPanelAtt?.breakdown_by?.length > 0 &&
                            axisPanelAtt?.breakdown_by[i]?.attribute &&
                            graphConditions?.["network-graph"]?.int?.exclude?.[
                              axisPanelAtt?.breakdown_by[
                                i
                              ]?.attribute?.toLowerCase()
                            ]
                              ? !graphConditions?.[
                                  "network-graph"
                                ]?.int?.exclude?.[
                                  axisPanelAtt?.breakdown_by[
                                    i
                                  ]?.attribute?.toLowerCase()
                                ]?.includes(op?.attribute)
                              : true
                          ) {
                            return (
                              <Option value={op?.attribute}>
                                {op?.trace_name}
                              </Option>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </Select>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              );
            })}
          </>
        ) : (
          ""
        )}
        {(chart_type === "grid" || chart_type === "pivot-grid") && (
          <Layout className="bg-white">
            <div className="text_regular font-weight600 mt-3">
              Columns <span className="error">*</span>
            </div>
            {axisPanelAtt?.x_axis && (
              <Content className="mt-1">
                <Droppable
                  droppableId={`y_axis#${
                    chart_type === "grid" ? "columns" : "columns_pivot"
                  }#attribute#update#x_axis`}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                      style={{
                        height: "4rem",
                        border: "0.1rem solid #C3CBD7",
                        backgroundColor:
                          authParams?.theme_type === "1" ? "" : "",
                      }}
                    >
                      <span className="cursor-pointer p-2 text_regular text-ellipsis">
                        <Tooltip
                          title={
                            All_WM_attributes[axisPanelAtt?.x_axis?.attribute]
                          }
                        >
                          {All_WM_attributes[axisPanelAtt?.x_axis?.attribute]
                            ?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.x_axis?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.x_axis?.attribute
                              ]}
                        </Tooltip>
                      </span>
                      <div
                        className="d-flex flex-row"
                        style={{
                          gap: "0.8rem",
                          alignItems: "center",
                          justifyItems: "center",
                        }}
                      >
                        <Tooltip title={"Attribute Configuration"}>
                          {" "}
                          <img
                            onClick={(e) =>
                              openEditFields({
                                series: "x_axis",
                                attName: axisPanelAtt?.x_axis?.attribute,
                                agg: axisPanelAtt?.x_axis?.aggregation,
                                x_limit: axisPanelAtt?.x_axis?.x_limit,
                                date_part: axisPanelAtt?.x_axis?.date_part,
                                chart_type: chart_type,
                                event: e,
                                span_on: axisPanelAtt?.x_axis?.span_on,
                                radius_attribute:
                                  axisPanelAtt?.x_axis?.radius_attribute,
                                seriesColor: axisPanelAtt?.x_axis?.color,
                              })
                            }
                            src={
                              authParams?.theme_type === "1"
                                ? SettingsLogo
                                : SettingLogoHover
                            }
                            alt="arrow"
                            className="accordionArrow cursor-pointer"
                            style={{
                              transform: `rotate("180deg")`,
                            }}
                          />
                        </Tooltip>
                        <CloseIcon
                          className="mr-2"
                          onClick={() => deleteAxisAttribute("x_axis")}
                        />
                      </div>
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            )}

            {axisPanelAtt?.breakdown_by &&
              (chart_type === "grid" || chart_type === "pivot-grid") &&
              axisPanelAtt?.breakdown_by?.map((d, i) => {
                if (!d?.is_pivot) {
                  return (
                    <Content className="mt-1">
                      <Droppable
                        droppableId={`y_axis#${
                          chart_type === "grid" ? "columns" : "columns_pivot"
                        }#attribute#update#breakdown_by#${i}`}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                            style={{
                              height: "4rem",
                              border: "0.1rem solid #C3CBD7",
                              backgroundColor:
                                authParams?.theme_type === "1" ? "" : "",
                            }}
                          >
                            <span className="cursor-pointer p-2 text_regular text-ellipsis">
                              <Tooltip title={All_WM_attributes[d?.attribute]}>
                                {All_WM_attributes[d?.attribute]?.length > 17
                                  ? All_WM_attributes[d?.attribute]?.substr(
                                      0,
                                      17
                                    ) + " ..."
                                  : All_WM_attributes[d?.attribute]}
                              </Tooltip>
                            </span>
                            <div
                              className="d-flex flex-row"
                              style={{
                                gap: "0.8rem",
                                alignItems: "center",
                                justifyItems: "center",
                              }}
                            >
                              <Tooltip title={"Attribute Configuration"}>
                                {" "}
                                <img
                                  onClick={(e) =>
                                    openEditFields({
                                      series: "breakdown",
                                      attName:
                                        axisPanelAtt?.breakdown_by[i]
                                          ?.attribute,
                                      date_part: axisPanelAtt?.breakdown_by[i]
                                        ?.date_part
                                        ? axisPanelAtt?.breakdown_by[i]
                                            ?.date_part
                                        : null,
                                      y_limit:
                                        axisPanelAtt?.breakdown_by[i]?.y_limit,
                                      chart_type: chart_type,
                                      breakdown_index: i,
                                      is_pivot:
                                        axisPanelAtt?.breakdown_by[i]?.is_pivot,
                                      event: e,
                                      span_on:
                                        axisPanelAtt?.breakdown_by[i]?.span_on,
                                      radius_attribute:
                                        axisPanelAtt?.breakdown_by[i]
                                          ?.radius_attribute,
                                      seriesColor:
                                        axisPanelAtt?.breakdown_by[i]?.color,
                                    })
                                  }
                                  src={
                                    authParams?.theme_type === "1"
                                      ? SettingsLogo
                                      : SettingLogoHover
                                  }
                                  alt="arrow"
                                  className="accordionArrow cursor-pointer "
                                  style={{
                                    transform: `rotate("180deg")`,
                                  }}
                                />
                              </Tooltip>
                              <CloseIcon
                                className="mr-2"
                                onClick={() =>
                                  deleteAxisAttribute("breakdown_by", null, i)
                                }
                              />
                            </div>
                            {provided?.placeholder && (
                              <div className="droppable-placeholder">
                                {provided?.placeholder}
                              </div>
                            )}
                          </div>
                        )}
                      </Droppable>
                    </Content>
                  );
                } else return null;
              })}

            {Object.entries(axisPanelAtt?.y_axis)?.map(
              (e) =>
                Object.entries(e[1]).length > 0 &&
                e[1]?.attribute !== null && (
                  <Content className="mt-1">
                    <Droppable
                      droppableId={`y_axis#${
                        chart_type === "grid" ? "columns" : "columns_pivot"
                      }#attribute#update#y_series#${e[0]}`}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                          style={{
                            height: "4rem",
                            border: "0.1rem solid #C3CBD7",
                            backgroundColor:
                              authParams?.theme_type === "1" ? "" : "",
                          }}
                        >
                          <span className="cursor-pointer p-2 text_regular text-ellipsis">
                            <Tooltip
                              title={All_WM_attributes[e?.[1]?.attribute]}
                            >
                              {All_WM_attributes[e?.[1]?.attribute]?.length > 17
                                ? All_WM_attributes[e?.[1]?.attribute]?.substr(
                                    0,
                                    17
                                  ) + " ..."
                                : All_WM_attributes[e?.[1]?.attribute]}
                            </Tooltip>
                          </span>
                          <div
                            className="d-flex flex-row"
                            style={{
                              gap: "0.8rem",
                              alignItems: "center",
                              justifyItems: "center",
                            }}
                          >
                            <Tooltip title={"Attribute Configuration"}>
                              {" "}
                              <img
                                onClick={(el) =>
                                  openEditFields({
                                    series: e[0],
                                    attName:
                                      axisPanelAtt?.y_axis[e[0]]?.attribute,
                                    agg: axisPanelAtt?.y_axis[e[0]]
                                      ?.aggregation,
                                    chart_type: chart_type,
                                    percent:
                                      axisPanelAtt?.y_axis[e[0]]?.percent,
                                    seriesColor:
                                      axisPanelAtt?.y_axis[e[0]]?.color,
                                    event: el,
                                    info_text:
                                      axisPanelAtt?.y_axis[e[0]]?.info_text,
                                  })
                                }
                                src={
                                  authParams?.theme_type === "1"
                                    ? SettingsLogo
                                    : SettingLogoHover
                                }
                                alt="arrow"
                                className="accordionArrow cursor-pointer"
                                style={{
                                  transform: `rotate("180deg")`,
                                }}
                              />
                            </Tooltip>
                            <CloseIcon
                              className="mr-2"
                              onClick={() => removeYSeries("y_axis", e[0])}
                            />
                          </div>
                          {provided?.placeholder && (
                            <div className="droppable-placeholder">
                              {provided?.placeholder}
                            </div>
                          )}
                        </div>
                      )}
                    </Droppable>
                  </Content>
                )
            )}

            {totalLength && (
              <Content className="mt-2">
                <Droppable
                  droppableId={`y_axis#${
                    chart_type === "grid" ? "columns" : "columns_pivot"
                  }#attribute`}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container cursor-pointer border-radius-4 p-2 w-100 text-center text_regular text-ellipsis"
                      style={{
                        height: "4rem",
                        border: `0.1rem ${totalLength ? "dashed" : "solid"} ${
                          axisPanelAtt?.dragDataType?.varchar
                            ? "#DDDDDD"
                            : totalLength
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        boxShadow:
                          chart_type === "grid"
                            ? axisPanelAtt?.breakdown_by?.length < 2
                            : axisPanelAtt?.breakdown_by?.length < 1 &&
                              (axisPanelAtt?.dragDataType?.varchar ||
                                axisPanelAtt?.dragDataType?.int) &&
                              axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                              axisPanelAtt?.dragDataType?.attribute !== "srs" &&
                              !graphConditions?.["time-label-attrs"]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              !graphConditions?.[
                                "ticket-time-label-attrs"
                              ]?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              y_series_array_drag?.includes(
                                axisPanelAtt?.dragDataType?.attribute
                              ) &&
                              `0 0.2rem 0.5rem ${
                                authParams?.theme_type === "1"
                                  ? "#fff"
                                  : "rgb(103 139 255 / 50%)"
                              }`,

                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : totalLength
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                    >
                      <span className="w-100 text-center text_regular no--wrap">
                        Drop fields here
                      </span>
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            )}

            {chart_type === "pivot-grid" && (
              <Content className="mt-2">
                <div className="text_regular font-weight600">
                  Group by <span className="error">*</span>
                </div>
                <Droppable
                  droppableId={`y_axis#pivot#attribute#${pivot_index}`}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container border-radius-4 p-2 w-100 text-left text_regular text-ellipsis"
                      style={{
                        height: "4rem",
                        border: `0.1rem ${
                          !axisPanelAtt?.breakdown_by?.length > 0 ||
                          pivot_index <= -1
                            ? "dashed"
                            : "solid"
                        } ${
                          axisPanelAtt?.dragDataType?.varchar
                            ? "#DDDDDD"
                            : !axisPanelAtt?.breakdown_by?.length > 0 ||
                              pivot_index <= -1
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        boxShadow:
                          axisPanelAtt?.dragDataType?.varchar &&
                          pivotGroupBy &&
                          `0 0.2rem 0.5rem ${
                            authParams?.theme_type === "1"
                              ? "#fff"
                              : "rgb(103 139 255 / 50%)"
                          }`,

                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : !axisPanelAtt?.breakdown_by?.length > 0 ||
                              pivot_index <= -1
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                    >
                      {!axisPanelAtt?.breakdown_by?.[0]?.attribute ||
                      pivot_index <= -1 ? (
                        <span className="cursor-pointer w-100 text-center text_regular d-inline-block no--wrap">
                          Drag fields here
                        </span>
                      ) : (
                        <div className="cursor-pointer w-100 d-flex justify-content-between align-items-center">
                          <span className="w-100 text_regular text-ellipsis">
                            {pivot_index > -1 && (
                              <Tooltip
                                title={
                                  All_WM_attributes[
                                    axisPanelAtt?.breakdown_by[pivot_index]
                                      ?.attribute
                                  ]
                                }
                              >
                                {All_WM_attributes[
                                  axisPanelAtt?.breakdown_by[pivot_index]
                                    ?.attribute
                                ]?.length > 17
                                  ? All_WM_attributes[
                                      axisPanelAtt?.breakdown_by[pivot_index]
                                        ?.attribute
                                    ]?.substr(0, 17) + " ..."
                                  : All_WM_attributes[
                                      axisPanelAtt?.breakdown_by[pivot_index]
                                        ?.attribute
                                    ]}
                              </Tooltip>
                            )}
                          </span>
                          {pivot_index > -1 && (
                            <div
                              className="d-flex flex-row"
                              style={{
                                gap: "0.8rem",
                                alignItems: "center",
                                justifyItems: "center",
                              }}
                            >
                              <Tooltip title={"Attribute Configuration"}>
                                {" "}
                                <img
                                  onClick={(e) =>
                                    openEditFields({
                                      series: "breakdown",
                                      attName:
                                        axisPanelAtt?.breakdown_by[pivot_index]
                                          ?.attribute,
                                      agg: axisPanelAtt?.breakdown_by[
                                        pivot_index
                                      ]?.aggregation,
                                      x_limit:
                                        axisPanelAtt?.breakdown_by[pivot_index]
                                          ?.x_limit,
                                      date_part: axisPanelAtt?.breakdown_by[
                                        pivot_index
                                      ]?.date_part
                                        ? axisPanelAtt?.breakdown_by[
                                            pivot_index
                                          ]?.date_part
                                        : null,
                                      y_limit:
                                        axisPanelAtt?.breakdown_by[pivot_index]
                                          ?.y_limit,
                                      chart_type: chart_type,
                                      breakdown_index: pivot_index,
                                      event: e,
                                      span_on:
                                        axisPanelAtt?.breakdown_by[pivot_index]
                                          ?.span_on,
                                    })
                                  }
                                  src={
                                    authParams?.theme_type === "1"
                                      ? SettingsLogo
                                      : SettingLogoHover
                                  }
                                  alt="arrow"
                                  className="accordionArrow ml-15"
                                  style={{
                                    transform: `rotate("180deg")`,
                                  }}
                                />
                              </Tooltip>
                              <CloseIcon
                                className="mr-2"
                                onClick={() =>
                                  deleteAxisAttribute(
                                    "breakdown_by",
                                    null,
                                    pivot_index
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            )}
          </Layout>
        )}
        {/* wordcolud filter pills */}
        {chart_type === "wordcloud" && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600 mt-3">Filter By</div>
              <Droppable droppableId="filter_by#word-cloud">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        axisPanelAtt?.filter_by?.length <= 0 ||
                        !axisPanelAtt?.filter_by
                          ? "dashed"
                          : "solid"
                      } ${
                        axisPanelAtt.dragDataType.varchar &&
                        !graphConditions[
                          "post-card"
                        ]?.y_axes?.exclude?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        )
                          ? "#DDDDDD"
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        axisPanelAtt.dragDataType.varchar &&
                        !graphConditions[
                          "post-card"
                        ]?.y_axes?.exclude?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {axisPanelAtt?.filter_by?.length <= 0 ||
                    !axisPanelAtt?.filter_by ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[
                              axisPanelAtt?.filter_by?.[0]?.attribute
                            ]
                          }
                        >
                          {All_WM_attributes[
                            axisPanelAtt?.filter_by?.[0]?.attribute
                          ]?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.filter_by &&
                      axisPanelAtt?.filter_by[0]?.attribute && (
                        <div
                          className="d-flex flex-row"
                          style={{
                            gap: "8px",
                            alignItems: "center",
                            justifyItems: "center",
                          }}
                        >
                          <Tooltip title={"Attribute Configuration"}>
                            {" "}
                            <img
                              onClick={(e) =>
                                openEditFields({
                                  series: "filter_by",
                                  attName:
                                    axisPanelAtt?.filter_by[0]?.attribute,
                                  x_limit: axisPanelAtt?.filter_by[0]?.x_limit,
                                  date_part: axisPanelAtt?.filter_by[0]
                                    ?.date_part
                                    ? axisPanelAtt?.filter_by[0]?.date_part
                                    : null,
                                  chart_type: chart_type,
                                  event: e,
                                })
                              }
                              src={
                                authParams?.theme_type === "1"
                                  ? SettingsLogo
                                  : SettingLogoHover
                              }
                              alt="arrow"
                              className="accordionArrow ml-15 cursor-pointer"
                              style={{
                                transform: `rotate("180deg")`,
                              }}
                            />
                          </Tooltip>
                          <CloseIcon
                            className="mr-2"
                            onClick={() => deleteAxisAttribute("filter_by")}
                          />
                        </div>
                      )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
          </Layout>
        )}
        {chart_type === "post-card" && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600">
                Order By <span className="error">*</span>
              </div>
              <Droppable droppableId="order_by#post-card">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        !axisPanelAtt?.order_by?.attribute ? "dashed" : "solid"
                      } ${
                        authParams?.theme_type === "1"
                          ? "#d9e5ed"
                          : axisPanelAtt?.dragDataType?.int
                          ? "#DDDDDD"
                          : !axisPanelAtt?.order_by?.attribute
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        axisPanelAtt?.dragDataType?.int &&
                        graphConditions?.[
                          "post-card"
                        ]?.order_by?.include?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                        axisPanelAtt?.dragDataType?.attribute !== "srs" &&
                        !graphConditions?.["time-label-attrs"]?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        !graphConditions?.["ticket-time-label-attrs"]?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        axisPanelAtt?.dragDataType?.attribute !== "tagid" &&
                        axisPanelAtt?.dragDataType?.attribute !== "authorid" &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : !axisPanelAtt?.order_by?.attribute
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {!axisPanelAtt.order_by?.attribute ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                          }
                        >
                          {All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                            ?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.order_by?.attribute && (
                      <CloseIcon
                        className="mr-2"
                        onClick={() => deleteAxisAttribute("order_by")}
                      />
                    )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
            <Content>
              <div className="text_regular font-weight600 mt-3">Filter By</div>
              <Droppable droppableId="filter_by#post-card">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        axisPanelAtt?.filter_by?.length <= 0 ||
                        !axisPanelAtt?.filter_by
                          ? "dashed"
                          : "solid"
                      } ${
                        authParams?.theme_type === "1"
                          ? "#9cb4ff"
                          : axisPanelAtt.dragDataType.varchar &&
                            !graphConditions[
                              "post-card"
                            ]?.y_axes?.exclude?.includes(
                              axisPanelAtt?.dragDataType?.attribute
                            )
                          ? "#DDDDDD"
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        axisPanelAtt.dragDataType.varchar &&
                        !graphConditions[
                          "post-card"
                        ]?.y_axes?.exclude?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {axisPanelAtt?.filter_by?.length <= 0 ||
                    !axisPanelAtt?.filter_by ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[
                              axisPanelAtt?.filter_by?.[0]?.attribute
                            ]
                          }
                        >
                          {All_WM_attributes[
                            axisPanelAtt?.filter_by?.[0]?.attribute
                          ]?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.filter_by &&
                      axisPanelAtt?.filter_by[0]?.attribute && (
                        <div
                          className="d-flex flex-row"
                          style={{
                            gap: "8px",
                            alignItems: "center",
                            justifyItems: "center",
                          }}
                        >
                          <Tooltip title={"Attribute Configuration"}>
                            {" "}
                            <img
                              onClick={(e) =>
                                openEditFields({
                                  series: "filter_by",
                                  attName:
                                    axisPanelAtt?.filter_by[0]?.attribute,
                                  x_limit: axisPanelAtt?.filter_by[0]?.x_limit,
                                  date_part: axisPanelAtt?.filter_by[0]
                                    ?.date_part
                                    ? axisPanelAtt?.filter_by[0]?.date_part
                                    : null,
                                  chart_type: chart_type,
                                  event: e,
                                })
                              }
                              src={
                                authParams?.theme_type === "1"
                                  ? SettingsLogo
                                  : SettingLogoHover
                              }
                              alt="arrow"
                              className="accordionArrow ml-15 cursor-pointer"
                              style={{
                                transform: `rotate("180deg")`,
                              }}
                            />
                          </Tooltip>
                          <CloseIcon
                            className="mr-2"
                            onClick={() => deleteAxisAttribute("filter_by")}
                          />
                        </div>
                      )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
          </Layout>
        )}
        {chart_type === "news-card" && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600">
                Order By <span className="error">*</span>
              </div>
              <Droppable droppableId="order_by#news-card">
                {(provided) => {
                  return (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="border-radius-4 d-flex text_regular justify-content-between align-items-center"
                      style={{
                        height: "40px",
                        border: `1px ${
                          !axisPanelAtt?.order_by?.attribute
                            ? "dashed"
                            : "solid"
                        } ${
                          authParams?.theme_type === "1"
                            ? "#d9e5ed"
                            : axisPanelAtt?.dragDataType?.int
                            ? "#DDDDDD"
                            : !axisPanelAtt?.order_by?.attribute
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        boxShadow:
                          axisPanelAtt?.dragDataType?.int &&
                          graphConditions?.[
                            "post-card"
                          ]?.order_by?.include?.includes(
                            axisPanelAtt?.dragDataType?.attribute
                          ) &&
                          axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                          axisPanelAtt?.dragDataType?.attribute !== "srs" &&
                          !graphConditions?.["time-label-attrs"]?.includes(
                            axisPanelAtt?.dragDataType?.attribute
                          ) &&
                          !graphConditions?.[
                            "ticket-time-label-attrs"
                          ]?.includes(axisPanelAtt?.dragDataType?.attribute) &&
                          axisPanelAtt?.dragDataType?.attribute !== "tagid" &&
                          axisPanelAtt?.dragDataType?.attribute !==
                            "authorid" &&
                          `0 2px 5px ${
                            authParams?.theme_type === "1"
                              ? "#fff"
                              : "rgb(103 139 255 / 50%)"
                          }`,

                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : !axisPanelAtt?.order_by?.attribute
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                      onChange={handleInput}
                    >
                      {!axisPanelAtt.order_by?.attribute ? (
                        <span className="cursor-pointer p-2 w-100 text-center text_regular">
                          Drag fields here
                        </span>
                      ) : (
                        <span
                          className="p-2 text-ellipsis"
                          style={{ maxWidth: "90%" }}
                        >
                          <Tooltip
                            title={
                              All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]
                            }
                          >
                            {All_WM_attributes[
                              axisPanelAtt?.order_by?.attribute
                            ]?.length > 17
                              ? All_WM_attributes[
                                  axisPanelAtt?.order_by?.attribute
                                ]?.substr(0, 17) + " ..."
                              : All_WM_attributes[
                                  axisPanelAtt?.order_by?.attribute
                                ]}
                          </Tooltip>
                        </span>
                      )}
                      {axisPanelAtt?.order_by?.attribute && (
                        <CloseIcon
                          className="mr-2"
                          onClick={() => deleteAxisAttribute("order_by")}
                        />
                      )}
                    </div>
                  );
                }}
              </Droppable>
            </Content>
          </Layout>
        )}
        {/* Removing chart_type === "survey-card" currently from here */}
        {chart_type === "review-card" && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600">
                Order By <span className="error">*</span>
              </div>
              <Droppable
                droppableId={`order_by#${
                  chart_type === "survey-card" ? "survey-card" : "review-card"
                }`}
              >
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        !axisPanelAtt.order_by?.attribute ? "dashed" : "solid"
                      } ${
                        authParams?.theme_type === "1"
                          ? "#9CB4FF"
                          : (axisPanelAtt.dragDataType.varchar ||
                              axisPanelAtt.dragDataType.datetime) &&
                            (axisPanelAtt.dragDataType.attribute ===
                              "CreatedDate" ||
                              axisPanelAtt.dragDataType.attribute === "Rating")
                          ? "#DDDDDD"
                          : !axisPanelAtt.order_by?.attribute
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        (axisPanelAtt.dragDataType.varchar ||
                          axisPanelAtt.dragDataType.datetime) &&
                        (axisPanelAtt.dragDataType.attribute ===
                          "CreatedDate" ||
                          axisPanelAtt.dragDataType.attribute === "Rating") &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : !axisPanelAtt?.order_by?.attribute
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {!axisPanelAtt.order_by?.attribute ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                          }
                        >
                          {All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                            ?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.order_by?.attribute && (
                      <CloseIcon
                        className="mr-2"
                        onClick={() =>
                          deleteAxisAttribute(
                            chart_type === "survey-card"
                              ? "survey-card"
                              : "review-card"
                          )
                        }
                      />
                    )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
            {/* to add filter by in review card */}
            <Content>
              <div className="text_regular font-weight600 mt-3">Filter By</div>
              <Droppable droppableId="filter_by#review-card">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        axisPanelAtt?.filter_by?.length <= 0 ||
                        !axisPanelAtt?.filter_by
                          ? "dashed"
                          : "solid"
                      } ${
                        authParams?.theme_type === "1"
                          ? "#9cb4ff"
                          : axisPanelAtt.dragDataType.varchar &&
                            graphConditions["review-attributes"]?.includes(
                              axisPanelAtt?.dragDataType?.attribute
                            )
                          ? "#DDDDDD"
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        axisPanelAtt.dragDataType.varchar &&
                        graphConditions["review-attributes"]?.includes(
                          axisPanelAtt?.dragDataType?.attribute
                        ) &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : axisPanelAtt?.filter_by?.length <= 0 ||
                            !axisPanelAtt?.filter_by
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {axisPanelAtt?.filter_by?.length <= 0 ||
                    !axisPanelAtt?.filter_by ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[
                              axisPanelAtt?.filter_by?.[0]?.attribute
                            ]
                          }
                        >
                          {All_WM_attributes[
                            axisPanelAtt?.filter_by?.[0]?.attribute
                          ]?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.filter_by?.[0]?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.filter_by &&
                      axisPanelAtt?.filter_by[0]?.attribute && (
                        <div
                          className="d-flex flex-row"
                          style={{
                            gap: "8px",
                            alignItems: "center",
                            justifyItems: "center",
                          }}
                        >
                          <Tooltip title={"Attribute Configuration"}>
                            {" "}
                            <img
                              onClick={(e) =>
                                openEditFields({
                                  series: "filter_by",
                                  attName:
                                    axisPanelAtt?.filter_by[0]?.attribute,
                                  x_limit: axisPanelAtt?.filter_by[0]?.x_limit,
                                  date_part: axisPanelAtt?.filter_by[0]
                                    ?.date_part
                                    ? axisPanelAtt?.filter_by[0]?.date_part
                                    : null,
                                  chart_type: chart_type,
                                  event: e,
                                })
                              }
                              src={
                                authParams?.theme_type === "1"
                                  ? SettingsLogo
                                  : SettingLogoHover
                              }
                              alt="arrow"
                              className="accordionArrow ml-15 cursor-pointer"
                              style={{
                                transform: `rotate("180deg")`,
                              }}
                            />
                          </Tooltip>
                          <CloseIcon
                            className="mr-2"
                            onClick={() => deleteAxisAttribute("filter_by")}
                          />
                        </div>
                      )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
          </Layout>
        )}
        {chart_type === "author-card" && (
          <Layout className="bg-white">
            <Content>
              <div className="text_regular font-weight600">
                Order By <span className="error">*</span>
              </div>
              <Droppable droppableId="order_by#author-card">
                {(provided) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    className="droppable-container border-radius-4 d-flex text_regular justify-content-between align-items-center"
                    style={{
                      height: "4rem",
                      border: `0.1rem ${
                        !axisPanelAtt.order_by?.attribute ? "dashed" : "solid"
                      } ${
                        authParams?.theme_type === "1"
                          ? "#d9e5ed"
                          : axisPanelAtt.dragDataType.int &&
                            (axisPanelAtt.dragDataType.attribute ===
                              "FollowersCount" ||
                              axisPanelAtt.dragDataType.attribute ===
                                "FollowingCount" ||
                              axisPanelAtt.dragDataType.attribute ===
                                "NumShareCount")
                          ? "#DDDDDD"
                          : !axisPanelAtt.order_by?.attribute
                          ? "#9CB4FF"
                          : "#d9e5ed"
                      }`,
                      boxShadow:
                        axisPanelAtt.dragDataType.int &&
                        (axisPanelAtt.dragDataType.attribute ===
                          "FollowersCount" ||
                          axisPanelAtt.dragDataType.attribute ===
                            "FollowingCount" ||
                          axisPanelAtt.dragDataType.attribute ===
                            "NumShareCount") &&
                        `0 0.2rem 0.5rem ${
                          authParams?.theme_type === "1"
                            ? "#fff"
                            : "rgb(103 139 255 / 50%)"
                        }`,

                      backgroundColor:
                        authParams?.theme_type === "1"
                          ? ""
                          : !axisPanelAtt?.order_by?.attribute
                          ? "#F2F7FF"
                          : "#FFFFFF",
                    }}
                    onChange={handleInput}
                  >
                    {!axisPanelAtt.order_by?.attribute ? (
                      <span className="cursor-pointer p-2 w-100 text-center text_regular no--wrap">
                        Drag fields here
                      </span>
                    ) : (
                      <span
                        className="p-2 text-ellipsis"
                        style={{ maxWidth: "90%" }}
                      >
                        <Tooltip
                          title={
                            All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                          }
                        >
                          {All_WM_attributes[axisPanelAtt?.order_by?.attribute]
                            ?.length > 17
                            ? All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]?.substr(0, 17) + " ..."
                            : All_WM_attributes[
                                axisPanelAtt?.order_by?.attribute
                              ]}
                        </Tooltip>
                      </span>
                    )}
                    {axisPanelAtt?.order_by?.attribute && (
                      <CloseIcon
                        className="mr-2"
                        onClick={() => deleteAxisAttribute("author-card")}
                      />
                    )}
                    {provided?.placeholder && (
                      <div className="droppable-placeholder">
                        {provided?.placeholder}
                      </div>
                    )}
                  </div>
                )}
              </Droppable>
            </Content>
          </Layout>
        )}{" "}
        {chart_type === "rich-text" ? (
          ""
        ) : (
          <>
            <Divider />
            <Layout className="bg-white">
              <Content>
                <div className="text_regular font-weight600 d-flex align-items-center">
                  Fields
                  <Tooltip
                    placement="top"
                    title="Add attributes in the fields area for quick analysis"
                  >
                    <img
                      src={informationButton}
                      alt="Info"
                      className="cursor-pointer ml-2"
                      style={{ maxWidth: "1.6rem" }}
                    />
                    {/* <span className="px-2 rounded-circle text-center bg-primary">
								<i>i</i>
							</span> */}
                  </Tooltip>
                </div>
                <Layout className="mb-2 bg-white">
                  {axisPanelAtt?.fields?.map((el, i) => (
                    <Droppable droppableId={`fields#${el}`} className="m-0">
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="mb-5"
                        >
                          <Draggable
                            draggableId={`${el.title}#${el.datatype}#fields`}
                            key={`${el.title}#${el.datatype}#fields`}
                            index={i}
                            className="m-0"
                          >
                            {(provide) => (
                              <Container
                                ref={provide.innerRef}
                                {...provide.draggableProps}
                                {...provide.dragHandleProps}
                                className="m-0"
                              >
                                <span className="text_regular">
                                  <Tooltip title={All_WM_attributes[el?.title]}>
                                    {All_WM_attributes[el?.title]?.length > 17
                                      ? All_WM_attributes[el?.title]?.substr(
                                          0,
                                          17
                                        ) + " ..."
                                      : All_WM_attributes[el?.title]}
                                  </Tooltip>
                                </span>
                                <CloseIcon
                                  onClick={() =>
                                    deleteAxisAttribute("fields", el)
                                  }
                                />
                              </Container>
                            )}
                          </Draggable>
                        </div>
                      )}
                    </Droppable>
                  ))}

                  {axisPanelAtt?.fields?.length < 5 && (
                    <Content className="mt-2">
                      <Droppable droppableId="fields">
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="droppable-container cursor-pointer border-radius-4 p-2 w-100 text-center text_regular"
                            style={{
                              height: "4rem",
                              border: "0.1rem dashed #9CB4FF",
                              backgroundColor:
                                authParams?.theme_type === "1" ? "" : "#F2F7FF",
                            }}
                          >
                            <span className="w-100 text-center text_regular no--wrap">
                              Drop fields here
                            </span>
                            {provided?.placeholder && (
                              <div className="droppable-placeholder">
                                {provided?.placeholder}
                              </div>
                            )}
                          </div>
                        )}
                      </Droppable>
                    </Content>
                  )}
                </Layout>
              </Content>
            </Layout>
          </>
        )}
        {/* Rich Text Widget: Selected Fields Section */}
        {chart_type === "rich-text" && (
          <Layout className="bg-white">
            <div className="text_regular font-weight600 mt-3">
              Fields<span className="error">*</span>
              <Tooltip
                placement="top"
                title="Data will be fetched on the basis of mention count by default, add attribute to change the sorting logic. Top 1 row will be fetched as of now for each attribute in combination together."
              >
                <img
                  src={informationButton}
                  alt="Info"
                  className="cursor-pointer ml-2"
                  style={{ maxWidth: "1.6rem" }}
                />
              </Tooltip>
            </div>
            {axisPanelAtt?.x_axis && (
              <Content className="mt-1 mb-2">
                <Droppable
                  droppableId={`y_axis#${"rich_fields"}#attribute#update#x_axis`}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                      style={{
                        height: "4rem",
                        border: `0.1rem ${
                          !axisPanelAtt?.x_axis?.attribute ? "dashed" : "solid"
                        } ${
                          !axisPanelAtt?.x_axis?.attribute
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : !axisPanelAtt?.x_axis?.attribute
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                    >
                      {/* can make this also draggable  */}
                      <div className="d-flex justify-content-between align-items-center w-100 p-2">
                        <span className="cursor-pointer text_regular text-ellipsis">
                          <Tooltip
                            title={
                              All_WM_attributes[axisPanelAtt?.x_axis?.attribute]
                            }
                          >
                            {All_WM_attributes[axisPanelAtt?.x_axis?.attribute]
                              ?.length > 17
                              ? All_WM_attributes[
                                  axisPanelAtt?.x_axis?.attribute
                                ]?.substr(0, 17) + " ..."
                              : All_WM_attributes[
                                  axisPanelAtt?.x_axis?.attribute
                                ]}
                          </Tooltip>
                        </span>
                        <CloseIcon
                          className="mr-2"
                          onClick={() => deleteAxisAttribute("x_axis")}
                        />
                      </div>
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            )}

            {/* Breakdown By section for Rich Text */}
            {axisPanelAtt?.breakdown_by &&
              axisPanelAtt?.breakdown_by?.map((d, i) => {
                return (
                  <Content className="mt-1 mb-2" key={`breakdown_by_id_${i}`}>
                    <Droppable
                      droppableId={`y_axis#${"rich_fields"}#attribute#update#breakdown_by#${i}`}
                      className="m-0"
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                          style={{
                            height: "4rem",
                            border: "0.1rem solid #C3CBD7",
                            backgroundColor:
                              authParams?.theme_type === "1" ? "" : "",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center w-100 p-2">
                            <span className="cursor-pointer text_regular text-ellipsis">
                              <Tooltip title={All_WM_attributes[d?.attribute]}>
                                {All_WM_attributes[d?.attribute]?.length > 17
                                  ? All_WM_attributes[d?.attribute]?.substr(
                                      0,
                                      17
                                    ) + " ..."
                                  : All_WM_attributes[d?.attribute]}
                              </Tooltip>
                            </span>
                            <CloseIcon
                              className="mr-2"
                              onClick={() =>
                                deleteAxisAttribute("breakdown_by", null, i)
                              }
                            />
                          </div>
                          {provided?.placeholder && (
                            <div className="droppable-placeholder">
                              {provided?.placeholder}
                            </div>
                          )}
                        </div>
                      )}
                    </Droppable>
                  </Content>
                );
              })}

            {/* Y-series section for Rich Text */}
            {Object.entries(axisPanelAtt?.y_axis || {})
              ?.filter((el) => axisPanelAtt?.y_axis[el?.[0]]?.attribute)
              ?.map(
                (e) =>
                  Object.entries(e[1]).length > 0 &&
                  e[1]?.attribute !== null &&
                  !e[1]?.hide_on_ui && (
                    <Content className="mt-1 mb-2" key={`yseries_${e[0]}`}>
                      <Droppable
                        droppableId={`y_axis#${"rich_fields"}#attribute#update#y_series#${
                          e[0]
                        }`}
                        className="m-0"
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className="droppable-container border-radius-4 text_regular d-flex justify-content-between align-items-center"
                            style={{
                              height: "4rem",
                              border: "0.1rem solid #C3CBD7",
                              backgroundColor:
                                authParams?.theme_type === "1" ? "" : "",
                            }}
                          >
                            <div className="d-flex justify-content-between align-items-center w-100 p-2">
                              <span className="cursor-pointer text_regular text-ellipsis">
                                <Tooltip
                                  title={All_WM_attributes[e?.[1]?.attribute]}
                                >
                                  {All_WM_attributes[e?.[1]?.attribute]
                                    ?.length > 17
                                    ? All_WM_attributes[
                                        e?.[1]?.attribute
                                      ]?.substr(0, 17) + " ..."
                                    : All_WM_attributes[e?.[1]?.attribute]}
                                </Tooltip>
                              </span>
                              <CloseIcon
                                className="mr-2"
                                onClick={() => removeYSeries("y_axis", e[0])}
                              />
                            </div>
                            {provided?.placeholder && (
                              <div className="droppable-placeholder">
                                {provided?.placeholder}
                              </div>
                            )}
                          </div>
                        )}
                      </Droppable>
                    </Content>
                  )
              )}
            {totalLength && (
              <Content className="mt-2">
                <Droppable droppableId={`y_axis#${"rich_fields"}#attribute`}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      className="droppable-container cursor-pointer border-radius-4 p-2 w-100 text-center text_regular text-ellipsis"
                      style={{
                        height: "4rem",
                        border: `0.1rem ${totalLength ? "dashed" : "solid"} ${
                          axisPanelAtt?.dragDataType?.varchar
                            ? "#DDDDDD"
                            : totalLength
                            ? "#9CB4FF"
                            : "#d9e5ed"
                        }`,
                        boxShadow:
                          axisPanelAtt?.breakdown_by?.length < 4 &&
                          (axisPanelAtt?.dragDataType?.varchar ||
                            axisPanelAtt?.dragDataType?.int) &&
                          axisPanelAtt?.dragDataType?.attribute !== "nss" &&
                          axisPanelAtt?.dragDataType?.attribute !== "srs" &&
                          !graphConditions?.["time-label-attrs"]?.includes(
                            axisPanelAtt?.dragDataType?.attribute
                          ) &&
                          !graphConditions?.[
                            "ticket-time-label-attrs"
                          ]?.includes(axisPanelAtt?.dragDataType?.attribute) &&
                          y_series_array_drag?.includes(
                            axisPanelAtt?.dragDataType?.attribute
                          ) &&
                          `0 0.2rem 0.5rem ${
                            authParams?.theme_type === "1"
                              ? "#fff"
                              : "rgb(103 139 255 / 50%)"
                          }`,

                        backgroundColor:
                          authParams?.theme_type === "1"
                            ? ""
                            : totalLength
                            ? "#F2F7FF"
                            : "#FFFFFF",
                      }}
                    >
                      <span className="w-100 text-center text_regular no--wrap">
                        Drag attribute here
                      </span>
                      {provided?.placeholder && (
                        <div className="droppable-placeholder">
                          {provided?.placeholder}
                        </div>
                      )}
                    </div>
                  )}
                </Droppable>
              </Content>
            )}
          </Layout>
        )}
        {isModalVisible ? (
          <EditFieldModal
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            editName={editName}
            setEditName={setEditName}
            editAggregation={editAggregation}
            setAggregation={setAggregation}
            filterSearch={filterSearch}
            setfilterSearch={setfilterSearch}
            isFilterApplied={isFilterApplied}
            setisFilterApplied={setisFilterApplied}
            widgetMakerClearFilter={widgetMakerClearFilter}
            setWidgetMakerClearFilter={setWidgetMakerClearFilter}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            callChartAPI={callChartAPI}
            onChange={onChange}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default EditAxisPanel;
